<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../../utilities/ArrayUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import FormsApi from '../../api/FormsApi'
import FormAccessApi from '../../api/FormAccessApi'
import ReportingGroupApi from '../../api/ReportingGroupApi'
import InputTypeLovApi from '../../api/InputTypeLovApi'
import FormFieldsApi from '../../api/FormFieldsApi'
import ValidationCardApi from '../../api/ValidationCardApi'
/** UI Components */
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Loading } from 'buefy/dist/components/loading'
import { Radio } from 'buefy/dist/components/radio'
import { Select } from 'buefy/dist/components/select'
import { Switch } from 'buefy/dist/components/switch'
import { Steps,StepItem } from 'buefy/dist/components/steps'
import { Table,TableColumn } from 'buefy/dist/components/table'
import EditReportingGroupFormVue from '../../components/EditReportingGroupForm.vue';

import _ from 'lodash'   

const STATIC_GRPNAME_GOV = 'Government Agencies'
const DEFAULT_PAGE_SIZE = 12

export default {
    name : "AddFormView",
    components: {
        'b-checkbox' : Checkbox,
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-steps' : Steps,
        'b-step-item' : StepItem,
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-radio' : Radio,
        'b-select' : Select,
        'b-switch' : Switch,
        'b-table' : Table,
        'b-table-column' : TableColumn,
        'b-loading' : Loading
    },
    data() {
        return {
            activeStep : 0,
            newFormData : {
                formName : "",
                repGroupAccess : [],
                repEntityAccess : [],
                repUnitAccess : []
            },
            repGroupLov : [],
            govAgencyGroup : null,
            hasNavigation : true,
            isAnimates : true,
            isStepsClickable : true,
            formNameInvalid : null,
            formNamePromise : false,
            formNameErrorMessage : "",
            existingFormAccess : [],
            isFormNameAccessSuccess : false,
            isFormAccessSettingSuccess : false,
            areFormFieldsAdded : false,
            // formAccess : [],
            savedFormData : {},
            groupedFormAccess : [],
            addNewFormPromise : false,
            inputTypesLov : [],
            formFields : [],
            selectedReportingYear : null,
            reportingYearLov : [],
            enableFileUpload : false,
            isLoading : false,
            isFullPage : false,
            globalError : {
                show : false,
                message : ""
            },
            globalLoading: null,
            pageSize: DEFAULT_PAGE_SIZE,
            groupedFields : [],
            allExpanded:  true
        }
    },
    computed: {
        ...mapState({
            // allForms : "allFormsData",
            profile : "userProfile",
            token : "xOreAuth"
        }),
        isFormValid(){
            
            if (!this.selectedReportingYear) {
                return false;
            }

            if (this.newFormData.formName.trim()=="") {
                return false
            }
            if (this.newFormData.repGroupAccess.length==0) {
                return false
            }

            var repGroupGov = this.repGroupLov.filter(group=>{
                return (group.reportingGroup==this.govAgencyGroup)
            });
                
            var repGroupGovId = repGroupGov[0].repGroupId;

            // Check if 'Government Agencies' option is selected
            if (ArrayUtil.inArray(this.newFormData.repGroupAccess,repGroupGovId)) {

                var selectedGovAgencies = 0;

                // Check if at least one of the agencies is checked
                this.repGroupLov.forEach(group=>{
                    if (group.repGroupId==repGroupGovId) {
                        group.reportingEntities.forEach(entity=>{
                            if (ArrayUtil.inArray(this.newFormData.repEntityAccess,entity.repEntityId)) {
                                selectedGovAgencies++;
                            }
                        })
                    }
                });

                // Prompt for warning to select at least one agency
                if (selectedGovAgencies==0) {
                    // Please select at least one rep entity.
                    return false;
                }
            }


            /** Check the rest of rep groups */
            let repGroupWithError = [];

            this.newFormData.repGroupAccess.forEach(grpId=>{
                if (grpId!=repGroupGovId) {

                    let groupData = this.repGroupLov.filter(grp=>{
                        return grp.repGroupId==grpId;
                    });

                    if (groupData.length) {
                        let countSelected = 0;
                        if (groupData[0].reportingEntities) {
                            let checkedEntities = groupData[0].reportingEntities.forEach(ent=>{
                                if (ArrayUtil.inArray(this.newFormData.repEntityAccess,ent.repEntityId)) {
                                    countSelected++;
                                }
                            });
                            if (countSelected==0){
                                repGroupWithError.push({
                                    reportingGroup : groupData[0].reportingGroup,
                                    repGroupId : groupData[0].repGroupId,
                                    countSelected
                                })
                            }
                        } 
                    }
                    
                }
            });

            if (repGroupWithError.length > 0) {
                return false;
            }
            return true;

        },
        hasFieldGroups () {
            var res = []
            if (this.groupedFields.length) {
                res = this.groupedFields.filter(grp => {
                    return grp.isField === false
                })
            }
            if (res.length > 0) {
                return true
            }
            return false
        },
        collapseAllLabel () {
            if (this.allExpanded) {
                return 'Collapse All Field Group'
            }
            return 'Expand All Field Group'
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        // this.isTokenValid();

        // Get list of reporting groups, entities and units for access
        this.getRepGroups();
        // Get input type lookup for fields section
        this.getInputTypesLov();
        this.getReportingYearLov();
    },
    methods: {
        ...mapMutations({
            clearAppData : "clearAppData",
            setAllFormsData: "updateAllFormsData"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                            }
                        }
                    }
                } 
            })
            .catch(error=>{
            })
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getRepGroups(){
            this.govAgencyGroup = STATIC_GRPNAME_GOV;
            this.repGroupLov = [];

            ReportingGroupApi.getAllData()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        var lov = response.data

                        /** For new implementation */
                        try {
                            if (lov.length > 0) {
                                lov.forEach(rg=>{
                                    var reWithUnits = []
                                    var reNoUnits = []
                                    var hasUnits = false
                                    var repEntIds = []
                                    var repUnitIds = []
                                    var newReportingEntities = []
                                    if (rg.reportingEntities.length > 0) {
                                        repEntIds = rg.reportingEntities.map(re=>{
                                            return re.repEntityId
                                        })
                                        reWithUnits = rg.reportingEntities.filter(re => {
                                            return re.reportingUnits.length > 0
                                        })
                                        reNoUnits = rg.reportingEntities.filter(re => {
                                            return re.reportingUnits.length === 0
                                        })               
                                        
                                    } 
                                    var pagedData = ArrayUtil.paginate(rg.reportingEntities, this.pageSize)
                                    this.$set(rg,'pagedData', pagedData)                         
                                    this.$set(rg,'currentPage', 0)
                                    if (rg.pagedData.length > 0) {
                                        this.$set(rg,'currentPage', 1)
                                    }
                                    this.$set(rg,'numPageItems',ArrayUtil.pageItems(rg.pagedData))
                                    newReportingEntities = [...reNoUnits, ...reWithUnits]
                                    if (reWithUnits.length > 0) {
                                        reWithUnits.forEach(re => {
                                            var currUnits = re.reportingUnits.map(ru =>{
                                                return ru.repUnitId
                                            })
                                            repUnitIds = [...repUnitIds, ...currUnits]
                                        })
                                        hasUnits = true
                                    }
                                    this.$set(rg,'repEntityIds',repEntIds)
                                    this.$set(rg,'repUnitIds',repUnitIds)
                                    this.$set(rg,'hasUnits',hasUnits)
                                    
                                    this.$set(rg,'expanded',false)
                                    this.$set(rg,'showUnits',false)
                                    this.$set(rg,'keywordFilter','')
                                })
                            }
                        } catch(lovErr) {
                            console.log(lovErr)
                        }

                        this.repGroupLov = lov; //response.data;

                        /** Get Gov Agency group for reference */
                        let govgroup =this.repGroupLov.filter(grp=>{
                            return grp.reportingGroup.match(/government agenc/gi);
                        });
                        if (govgroup.length > 0) {
                            this.govAgencyGroup = govgroup[0].reportingGroup;
                        }
                        else {
                            this.govAgencyGroup = STATIC_GRPNAME_GOV;
                        }

                        // Pre-select all entities and units
                        this.repGroupLov.forEach(group=>{
                            group.reportingEntities.forEach(entity=>{
                                if (group.reportingGroup!==this.govAgencyGroup) { // 'Government Agencies
                                    this.newFormData.repEntityAccess.push(entity.repEntityId);
                                }
                                entity.reportingUnits.forEach(unit=>{
                                    this.newFormData.repUnitAccess.push(unit.repUnitId);
                                })
                            })
                        })
                    }
                    else {
                        this.promptServerError({response},'ReportingGroup.getAllGroupData');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingGroup.getAllGroupData');
            });
        },
        getInputTypesLov(){
            this.inputTypesLov = [];
            InputTypeLovApi.get()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.inputTypesLov = response.data;
                    }
                    else {
                        this.promptServerError({response},'InputTypeLov.get');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'InputTypeLov.get');
            });
        },
        getReportingYearLov(){
            this.isLoading = true;
            this.reportingYearLov = [];
            this.selectedReportingYear = null;
            let staticYrs = AppResourceUtil.getRepYrStaticLov();

            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {

                        let repYearInDb = [];
                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();

                        if (this.$route.query) {
                            try {
                                if (this.$route.query.reportingYear) {
                                    this.selectedReportingYear = parseInt(this.$route.query.reportingYear,10);
                                }
                            }
                            catch(formIdErr){}
                        }
                        this.isLoading = false;
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },  
        checkFormName: _.debounce(function(){
            this.formNameInvalid = null;
            this.formNamePromise = true;
            this.formNameErrorMessage = "";
            this.existingFormAccess = [];
            if (this.newFormData) {
                if (this.newFormData.formName.trim().length > 3) {
                    FormsApi.getFormName({
                        formName: this.newFormData.formName
                    })
                    .then(response=>{
                        if (response.data) {
                            if (!response.data.error) {
                                this.formNameInvalid = response.data.isExisting;
                                this.existingFormAccess = response.data.accessData;
                                this.formNamePromise = false;

                                if (this.formNameInvalid) {
                                    this.formNameErrorMessage = "There's an existing form with the same name. If you're to keep this name, please ensure that reporting group access is different.";
                                }
                                else {
                                    this.formNameErrorMessage = "Form name is valid.";
                                }
                            }
                            else {
                                this.formNamePromise = false;
                                this.promptServerError({response},'Form.getFormName');
                            }
                        }
                    })
                    .catch(error=>{
                        this.formNamePromise = false;
                        this.promptServerError(error,'Form.getFormName');
                    })
                }
                else {
                    this.formNamePromise = false;
                }
            }
        },350),
        govGroupValid(){
            if (this.repGroupLov) {

                var repGroupGov = this.repGroupLov.filter(group=>{
                    return (group.reportingGroup==this.govAgencyGroup)
                });
                    
                var repGroupGovId = repGroupGov[0].repGroupId;

                // Check if 'Government Agencies' option is selected
                if (ArrayUtil.inArray(this.newFormData.repGroupAccess,repGroupGovId)) {

                    var selectedGovAgencies = 0;

                    // Check if at least one of the agencies is checked
                    this.repGroupLov.forEach(group=>{
                        if (group.repGroupId==repGroupGovId) {
                            group.reportingEntities.forEach(entity=>{
                                if (ArrayUtil.inArray(this.newFormData.repEntityAccess,entity.repEntityId)) {
                                    selectedGovAgencies++;
                                }
                            })
                        }
                    });

                    // Prompt for warning to select at least one agency
                    if (selectedGovAgencies==0) {
                        // Please select at least one rep entity.
                        return false;
                    }
                }
            }
            return true;
        },
        otherGroupValid(){
            /** Check the rest of rep groups */
            let repGroupWithError = [];

            var repGroupGov = this.repGroupLov.filter(group=>{
                return (group.reportingGroup==this.govAgencyGroup)
            });
                
            var repGroupGovId = repGroupGov[0].repGroupId;

            if (this.newFormData.repGroupAccess) {
                this.newFormData.repGroupAccess.forEach(grpId=>{
                    if (grpId!=repGroupGovId) {

                        let groupData = this.repGroupLov.filter(grp=>{
                            return grp.repGroupId==grpId;
                        });

                        if (groupData.length) {
                            let countSelected = 0;
                            if (groupData[0].reportingEntities) {
                                let checkedEntities = groupData[0].reportingEntities.forEach(ent=>{
                                    if (ArrayUtil.inArray(this.newFormData.repEntityAccess,ent.repEntityId)) {
                                        countSelected++;
                                    }
                                });
                                if (countSelected==0){
                                    repGroupWithError.push({
                                        reportingGroup : groupData[0].reportingGroup,
                                        repGroupId : groupData[0].repGroupId,
                                        countSelected
                                    })
                                }
                            } 
                        }
                        
                    }
                });
                if (repGroupWithError.length > 0) {
                    return false
                }
            }
            return true;
        },
        addNewFormData(){
            this.savedFormData = {};
            this.closeError();

            if (this.newFormData.formName.trim()=="") {
                return false
            }
            // if (this.formNameInvalid) {
            //     return false
            // }
            if (this.newFormData.repGroupAccess.length==0) {
                this.showError('Please select at least one reporting group and entity for form access.');
                return false
            }

            if (this.govGroupValid()==false) {
                this.showError('Please select at least one entity from selected reporting group.');
                return false
            }

            if (this.otherGroupValid()==false){
                this.showError('Please select at least one entity from selected reporting group.');
                return false
            }
            
            // Form data is ready for submission

            this.addNewFormPromise = true;

            // Get Access
            var selectedRepGroup = this.repGroupLov.filter(group=>{
                // Get checked reporting groups
                return (ArrayUtil.inArray(this.newFormData.repGroupAccess,group.repGroupId))
            });

            if (selectedRepGroup.length > 0) {

                selectedRepGroup.forEach(group=>{
                    group.selectedRepEntities = group.reportingEntities.filter(entity=>{
                        // Get checked reporting groups
                        return (ArrayUtil.inArray(this.newFormData.repEntityAccess,entity.repEntityId))
                    })
                })

                selectedRepGroup.forEach(group=>{
                    group.selectedRepEntities.forEach(entity=>{
                        entity.selectedRepUnits = [];
                        entity.selectedRepUnits = entity.reportingUnits.filter(unit=>{
                            // Get checked reporting groups
                            return (ArrayUtil.inArray(this.newFormData.repUnitAccess,unit.repUnitId))
                        })
                    })
                });

                var formAccess = [];
                this.groupedFormAccess = [];

                selectedRepGroup.forEach(group=>{

                    // Form access data for submission
                    formAccess.push({
                        accessLevel : 'Reporting Group',
                        repGroupIdFk : group.repGroupId,
                        repEntityIdFk : null,
                        repUnitIdFk : null,
                        formSubmissionType : "Single",
                        displayOption : "List",
                        addedBy: this.profile.userId
                    })
                    
                    if (group.selectedRepEntities.length > 0) {
                        group.selectedRepEntities.forEach(entity=>{

                            // Form access data for submission
                            formAccess.push({
                                accessLevel : 'Reporting Entity',
                                repGroupIdFk : entity.repGroupIdFk,
                                repEntityIdFk : entity.repEntityId,
                                repUnitIdFk : null,
                                formSubmissionType : "Single",
                                displayOption : "List",
                                addedBy: this.profile.userId
                            })

                            if (entity.selectedRepUnits.length > 0) {

                                entity.selectedRepUnits.forEach(unit=>{
                                    // Form access data for submission
                                    formAccess.push({
                                        accessLevel : 'Reporting Unit', 
                                        repGroupIdFk : entity.repGroupIdFk,
                                        repEntityIdFk : unit.repEntityIdFk,
                                        repUnitIdFk : unit.repUnitId,
                                        formSubmissionType : "Single",
                                        displayOption : "List",
                                        addedBy: this.profile.userId
                                    });
                                });
                            }

                        });
                    }

                });

                // If formName is existing already, 
                // check if form access is different;
                let hasSameAccess = true;
                
                if (this.formNameInvalid) {
                    if (formAccess.length > 0) {

                        if (this.existingFormAccess.length > 0) {
                            let existingRepGrpAccess = [], existingRepEntAccess = [], existingRepUnitAccess = [];
                            let newRepGrpAccess = [], newRepEntAccess = [], newRepUnitAccess = [];

                            existingRepGrpAccess = this.filterAccessDataById(this.existingFormAccess,'Reporting Group','repGroupIdFk');
                            existingRepEntAccess = this.filterAccessDataById(this.existingFormAccess,'Reporting Entity','repEntityIdFk');
                            existingRepUnitAccess = this.filterAccessDataById(this.existingFormAccess,'Reporting Unit','repUnitIdFk');

                            newRepGrpAccess = this.filterAccessDataById(formAccess,'Reporting Group','repGroupIdFk');
                            newRepEntAccess = this.filterAccessDataById(formAccess,'Reporting Entity','repEntityIdFk');
                            newRepUnitAccess = this.filterAccessDataById(formAccess,'Reporting Unit','repUnitIdFk');

                            // Check existing form access has the same reporting assignment 
                            if (JSON.stringify(existingRepGrpAccess)==JSON.stringify(newRepGrpAccess) &&
                                JSON.stringify(existingRepEntAccess)==JSON.stringify(newRepEntAccess) &&
                                JSON.stringify(existingRepUnitAccess)==JSON.stringify(newRepUnitAccess) ) {
                                hasSameAccess = true;
                            }
                            else {
                                // Check if existing form access is a subset of new reporting assignment
                                let isRgSubset = existingRepGrpAccess.every(function(val) { 
                                    return (newRepGrpAccess.indexOf(val) >= 0); 
                                }); 
                                let isRpSubset = existingRepEntAccess.every(function(val) { 
                                    return (newRepEntAccess.indexOf(val) >= 0); 
                                }); 
                                let isRuSubset = existingRepUnitAccess.every(function(val) { 
                                    return (newRepUnitAccess.indexOf(val) >= 0); 
                                }); 

                                // If existing form access is a subset new form access
                                if (isRgSubset && isRpSubset && isRuSubset) {
                                    hasSameAccess = true; 
                                }
                                else {
                                    hasSameAccess = false;
                                }

                            }

                        }
                        else {
                            hasSameAccess = false;
                        }
                    }
                }

                if (this.formNameInvalid) {
                    if (hasSameAccess==true) {
                        // this.formNameErrorMessage = 'Form name exists and has same form access. Please select a different name or access.';
                        
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Looks like this form already exists. The system found a form with the same name and detected a similiar group/entity assignment. Please check your input and try again.",
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa'
                        });
                        this.addNewFormPromise = false;
                        return false;
                    }
                }
                
                // Submit
                FormsApi.add({
                    formData : {
                        formName: this.newFormData.formName,
                        isActive: true,
                        isPublished: false,
                        createdBy: this.profile.userId,
                        reportingYear: this.selectedReportingYear
                    },
                    accessData : formAccess
                })
                .then(response=>{
                    var data = response.data;
                    var formId = null, formAccessData = [];
                    if (response.data) {
                        if (!response.data.error) {
                            // Get form id
                            if (data.formId!==null) {
                                formId = data.formId;
                                this.savedFormData = {
                                    formId : data.formId
                                }
                            } 
                            // Get form access
                            if (data.formAccess!==null) {
                                formAccessData = data.formAccess;

                                // Initialize entities array in group access
                                formAccessData.repGroupAccess.forEach(group=>{
                                    group.reportingEntities = []
                                    
                                    /** For new implementation */
                                    this.$set(group,'keywordFilter', '')
                                    this.$set(group,'pagedData', [])                    
                                    this.$set(group,'currentPage', 0)
                                    this.$set(group,'numPageItems', 0)
                                    this.$set(group,'expanded', false)
                                    this.$set(group,'showUnits', false)
                                    this.$set(group,'hasUnits', false)
                                });

                                // Initialize units array in entity access
                                // Add entities to corresponding group access
                                formAccessData.repEntityAccess.forEach(entity=>{
                                    entity.reportingUnits = [];
                                    var groupIdx = ArrayUtil.getIndex(formAccessData.repGroupAccess,'repGroupIdFk',entity.repGroupIdFk);
                                    if (groupIdx!=null) {
                                        formAccessData.repGroupAccess[groupIdx].reportingEntities.push(entity);
                                    }
                                });

                                // Add units to corresponding entity access
                                formAccessData.repUnitAccess.forEach(unit=>{
                                    var entityIdx = ArrayUtil.getIndex(formAccessData.repEntityAccess,'repEntityIdFk',unit.repEntityIdFk);
                                    var groupIdx = ArrayUtil.getIndex(formAccessData.repGroupAccess,'repGroupIdFk',unit.repGroupIdFk);
                                    if (entityIdx!=null) {
                                        formAccessData.repGroupAccess[groupIdx].hasUnits = true
                                        formAccessData.repEntityAccess[entityIdx].reportingUnits.push(unit);
                                    }
                                });

                                /** For new implementation */
                                if (formAccessData.repGroupAccess.length > 0) {
                                    /** Set pagination and initialize current page and total items */
                                    formAccessData.repGroupAccess.forEach(rgAccess=>{
                                        if (rgAccess.reportingEntities.length > 0) {
                                            rgAccess.pagedData = ArrayUtil.paginate(rgAccess.reportingEntities, this.pageSize)
                                            rgAccess.numPageItems = ArrayUtil.pageItems(rgAccess.pagedData)
                                            if (rgAccess.pagedData.length > 0) {
                                                rgAccess.currentPage = 1
                                            }
                                        }
                                    })
                                }

                                this.groupedFormAccess = formAccessData.repGroupAccess;
                            } 

                            this.$notification.open({
                                duration: 5000,
                                message: 'Form added. Select submission type and display option.',
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });

                            this.addNewFormPromise = false;
                            this.isFormNameAccessSuccess = true;
                            this.isFormAccessSettingSuccess = false;
                            this.activeStep = 1;
                        }
                        else {
                            this.addNewFormPromise = false;
                            this.promptServerError({response},'Form.add');
                        }
                    }
                })
                .catch(error=>{
                    this.promptServerError(response,'Form.add');
                    this.addNewFormPromise = false;
                })
            }
        },
        filterAccessDataById(data,level,field){
            let resultArr = this.filterAccessLevel(data,level);
            return this.getFormAccessIds(resultArr,field);
        },
        filterAccessLevel(data,level){
            // Returns filtered data using 'accessLevel' field
            let filteredData = [];
            if (data.length > 0) {
                filteredData = data.filter(acc=>{
                    return (acc.accessLevel==level)
                });
            }
            return filteredData;
        },
        getFormAccessIds(data,field){
            // Returns value of whichever 'field' is specified
            let returnData = [];
            if (data.length > 0) {
                returnData = data.map(acc=>{
                    return acc[field]
                });
            }
            return returnData;
        },
        getForm(){
            if (!this.savedFormData.formId) {
                this.$dialog.alert({
                    title: 'Error',
                    message: 'No form found. Please reload and try again.',
                    type: 'is-danger'
                });
                return false
            }

            this.showLoading()
            this.newFormData.formName = ""
            this.newFormData.repGroupAccess = []
            this.newFormData.repEntityAccess = []
            this.newFormData.repUnitAccess = []
            this.enableFileUpload = false
            
            FormsApi.getOne(this.savedFormData.formId)
            .then(response=>{
                this.closeLoading()
                if (response.data) {
                    if (!response.data.error){
                        if (response.data.isPublished==true) {
                            this.$dialog.alert({
                                title: 'Error',
                                message: 'This form is already published. Edit is no longer allowed.',
                                type: 'is-danger'
                            });
                            this.$router.push({path:"/admin/forms/"+this.savedFormData.formId+'/preview?reportingYear='+response.data.reportingYear});
                            return false
                        }
                        // this.originalFormData = response.data;
                        var originalFormData = response.data
                        if (response.data.reportingYear) {
                            originalFormData.reportingYear = response.data.reportingYear;
                            this.selectedReportingYear = response.data.reportingYear;
                        }                        
                        this.newFormData.formName = response.data.formName;
                        originalFormData.repGroupAccess = [];
                        originalFormData.repEntityAccess = [];
                        originalFormData.repUnitAccess = [];

                        this.enableFileUpload = response.data.filesEnabled;
                        this.setAccessData(originalFormData);
                    }
                    else {
                        this.promptServerError({response},'Form.getOne');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'Form.getOne');
            });
        },
        setAccessData(originalFormData){
            if (originalFormData.groupedFormAccessData.length > 0) {
                this.groupedFormAccess = []
                originalFormData.groupedFormAccessData.forEach(group=>{
                    
                    group.accessLevel = 'Reporting Group'
                    this.newFormData.repGroupAccess.push(group.repGroupIdFk)

                    this.$set(group,'keywordFilter', '')
                    this.$set(group,'pagedData', [])                    
                    this.$set(group,'currentPage', 0)
                    this.$set(group,'numPageItems', 0)
                    this.$set(group,'expanded', false)
                    this.$set(group,'showUnits', false)
                    this.$set(group,'hasUnits', false)
                    
                    if (group.reportingEntities.length > 0) {
                        group.reportingEntities.forEach(entity=>{
                            entity.accessLevel = 'Reporting Entity'
                            this.newFormData.repEntityAccess.push(entity.repEntityIdFk);

                            if (entity.reportingUnits.length > 0) {
                                this.$set(group,'hasUnits', true)
                                entity.reportingUnits.forEach(unit=>{
                                    unit.accessLevel = 'Reporting Unit'
                                    this.newFormData.repUnitAccess.push(unit.repUnitIdFk);
                                })
                            }
                        })
                        this.$set(group,'pagedData', ArrayUtil.paginate(group.reportingEntities, this.pageSize))                                            
                    }

                    if (group.pagedData.length > 0) {
                        this.$set(group,'currentPage', 1)
                        this.$set(group,'numPageItems', ArrayUtil.pageItems(group.pagedData))
                    }
                    this.groupedFormAccess.push(group)
                })
            }
        },
        saveFormSetting(proceed){
            if (proceed==1) {
                this.activeStep = 2;
                this.isFormAccessSettingSuccess = true;
                this.addFieldRow();
                return false;
            }
            this.isFormAccessSettingSuccess = true;
            this.$router.push({path:"/admin/forms?reportingYear="+this.selectedReportingYear});
        },
        isGroupSelected(repGroup) {
            if (repGroup) {
                return ArrayUtil.inArray(this.newFormData.repGroupAccess,repGroup.repGroupId)
            }
        },
        isEntitySelected(entity){
            if (entity) {
                return ArrayUtil.inArray(this.newFormData.repEntityAccess,entity.repEntityId)
            }
        },
        checkAccess(level,repGroup,entity) {
            let selectedGroup = this.getGroupEntitiesUnits(repGroup.repGroupId);
            if (level==0) {
                // When rep group is unchecked
                // uncheck also the entities/units
                let action = "";
                if (this.isAccessNew(0,repGroup.repGroupId)==false){
                    // unchecked
                    action = 'remove';
                }
                else {                    
                    // checked
                    action = 'add';
                }
                if (selectedGroup.entities.length > 0) {
                    this.markEntities(selectedGroup.entities,action,repGroup); // Change to formEntities 
                }
                if (selectedGroup.units.length > 0) {
                    this.markUnits(selectedGroup.units,action,repGroup,null); // Change to formUnits
                }
            }
            else if (level==1 && entity) {
                let action = "";
                if (this.isAccessNew(1,entity.repEntityId)==false){
                    // unchecked
                    action = 'remove';
                }
                else {                    
                    // checked
                    action = 'add';
                }
                if (selectedGroup.units.length > 0) {
                    if (entity.reportingUnits.length > 0) {
                        var repEntUnits = entity.reportingUnits.map(u=>{
                            return u.repUnitId
                        })
                        this.markUnits(selectedGroup.units,action,repGroup,repEntUnits); // Change to formUnits
                    }
                }
            }
        },
        getGroupEntitiesUnits(repGroupIdFk){
            let entities = [], formEntities = [];
            let units = [], formUnits = [];
            this.repGroupLov.forEach(group=>{
                if (group.repGroupId==repGroupIdFk) {
                    if (group.reportingEntities.length > 0) {
                        // Get Entities
                        group.reportingEntities.forEach(entity=>{
                            entities.push(entity.repEntityId);

                            // Get Units
                            if (entity.reportingUnits.length > 0) {
                                entity.reportingUnits.forEach(unit=>{
                                    units.push(unit.repUnitId)
                                });
                            }
                        })
                    }
                }
            });
            return {
                entities,
                units,
                formEntities,
                formUnits
            }
        },
        markEntities(entityIds,action,repGroup){
            let newRepEntAccess = [];
            if (action=='remove') {
                // When unchecked
                this.newFormData.repEntityAccess.forEach(aId=>{
                    if (ArrayUtil.inArray(entityIds,aId)==false) {
                        newRepEntAccess.push(aId);
                    }
                });
                this.newFormData.repEntityAccess = newRepEntAccess
            }
            else {
                if (repGroup.reportingGroup!==this.govAgencyGroup) {
                    // When checked
                    entityIds.forEach(eId=>{
                        if (this.isAccessNew(1,eId)==false){
                            this.newFormData.repEntityAccess.push(eId);
                        }
                    })
                }
            }    
        },
        markUnits(unitIds,action,repGroup,repEntUnits){
            let newRepUnitAccess = [];
            if (action=='remove') {
                // When unchecked
                if (!repEntUnits) {
                    this.newFormData.repUnitAccess.forEach(aId=>{
                        if (ArrayUtil.inArray(unitIds,aId)==false) {
                            newRepUnitAccess.push(aId);
                        }  
                    })
                }
                else {
                    this.newFormData.repUnitAccess.forEach(aId=>{
                        if (ArrayUtil.inArray(repEntUnits,aId)==false) {
                            newRepUnitAccess.push(aId);
                        }  
                    })
                }
                this.newFormData.repUnitAccess = newRepUnitAccess;
            }
            else {
                // When checked
                unitIds.forEach(uId=>{
                    if (this.isAccessNew(2,uId)==false) {
                        this.newFormData.repUnitAccess.push(uId);
                    }
                });
            }    
        },
        isAccessNew(level,id) {
            switch(level) {
                case 0: // Reporting Group Access
                    return ArrayUtil.inArray(this.newFormData.repGroupAccess,id);
                    break;
                case 1: // Reporting Entity Access
                    return ArrayUtil.inArray(this.newFormData.repEntityAccess,id);
                    break;
                case 2: // Reporting Unit Access
                    return ArrayUtil.inArray(this.newFormData.repUnitAccess,id);
                    break;
            }
        },
        selectSubmissionType(data,type){
            if (!type) {
                type = data.formSubmissionType
            }

            var accessIdsToUpdate = [];
            
            // Apply new submission type for selected group/entity
            /** 
            * Button Group Implementation: 
            * this.$set(data,'formSubmissionType',type);
            * */            
            accessIdsToUpdate.push(data.accessId);

            if (data.accessLevel=='Reporting Group') {
                // Apply selected submission type under this group 
                if (data.reportingEntities.length > 0) {
                    data.reportingEntities.forEach(entity=>{
                        // Apply to Reporting Entities
                        /** 
                        * Button Group Implementation: 
                        * entity.formSubmissionType = type;
                        * */
                        accessIdsToUpdate.push(entity.accessId);

                        if (entity.reportingUnits.length > 0) {
                            entity.reportingUnits.forEach(unit=>{
                                // Apply to Reporting Units
                                /** 
                                * Button Group Implementation: 
                                * unit.formSubmissionType = type;
                                * */
                                accessIdsToUpdate.push(unit.accessId);
                            })
                        }
                    });
                }
            }
            else if (data.accessLevel=='Reporting Entity') {
                if (data.reportingUnits.length > 0) {
                    data.reportingUnits.forEach(unit=>{
                        // Apply to Reporting Units
                        /** 
                        * Button Group Implementation: 
                        * unit.formSubmissionType = type;
                        * */
                        accessIdsToUpdate.push(unit.accessId);
                    })
                }
            }

            var newAccessData = {
                accessIds : accessIdsToUpdate,
                accessLevel : data.accessLevel,
                formIdFk : this.savedFormData.formId,
                fieldName : 'formSubmissionType',
                fieldValue : type,
                updatedBy : this.profile.userId
            };

            this.saveSetting(newAccessData);
        },
        selectDisplayOption(data,option){
            if (!option) {
                option = data.displayOption
            }

            var accessIdsToUpdate = [];
            // Apply new submission type for selected group/entity
            /** 
            * Button Group Implementation: 
            * this.$set(data,'displayOption',option);
            * */
            accessIdsToUpdate.push(data.accessId);

            if (data.accessLevel=='Reporting Group') {
                // Apply selected submission type under this group 
                if (data.reportingEntities.length > 0) {
                    data.reportingEntities.forEach(entity=>{
                        // Apply to Reporting Entities
                        /** 
                        * Button Group Implementation: 
                        * entity.displayOption = option;
                        * */
                        accessIdsToUpdate.push(entity.accessId);

                        if (entity.reportingUnits.length > 0) {
                            entity.reportingUnits.forEach(unit=>{
                                // Apply to Reporting Units
                                /** 
                                * Button Group Implementation: 
                                * unit.displayOption = option;
                                * */
                                accessIdsToUpdate.push(unit.accessId);
                            })
                        }
                    });
                }
            }
            else if (data.accessLevel=='Reporting Entity') {
                if (data.reportingUnits.length > 0) {
                    data.reportingUnits.forEach(unit=>{
                        // Apply to Reporting Units
                        /** 
                        * Button Group Implementation: 
                        * unit.displayOption = option;
                        * */
                        accessIdsToUpdate.push(unit.accessId);
                    })
                }
            }

            var newAccessData = {
                accessIds : accessIdsToUpdate,
                accessLevel : data.accessLevel,
                formIdFk : this.savedFormData.formId,
                fieldName : 'displayOption',
                fieldValue : option,
                updatedBy : this.profile.userId
            };

            this.saveSetting(newAccessData);
        },
        showLoading(){
            this.globalLoading = null
            this.globalLoading = this.$loading.open({
                container: null
            })
        },
        closeLoading(){
            try {
                if (this.globalLoading) {
                    this.globalLoading.close()
                }    
                this.globalLoading = null
            } catch(loadingErr) {
                console.log(loadingErr)
            }
        },
        saveSetting(accessData){
            this.showLoading()
            FormAccessApi.update(accessData)
            .then(response=>{
                this.closeLoading()
                if (response.data) {
                    if (!response.data.error) {
                        this.getForm()
                        this.$notification.open({
                            duration: 3000,
                            message: 'Saved!',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                    }
                    else {
                        this.promptServerError({response},'FormAccess.update');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'FormAccess.update');
            })
        },
        cancel(){
            // Check if there's progress in the forms
            if (this.newFormData.formName.trim().length > 0 ||
                this.newFormData.repGroupAccess.length > 0) {
                this.$dialog.confirm({
                    title: 'Confirmation',
                    message: 'You have unsaved changes. Are you sure you want to leave this page?',
                    cancelText: 'Stay',
                    confirmText: 'Leave Page',
                    type: 'is-warning',
                    onConfirm: () => {
                        this.$router.push({path:"/admin/forms?reportingYear="+this.selectedReportingYear});
                    }
                })
                return false;
            }
            // Go back to /forms
            this.$router.push({path:"/admin/forms?reportingYear="+this.selectedReportingYear});
        },
        hasOptions(id){
            let fieldTypes = ['dropdown','checkbox','radio'];
            let selectedInput = this.inputTypesLov.filter(inputType=>{
                return (inputType.typeId == id)
            });
            if (selectedInput[0]) {
                if (ArrayUtil.inArray(fieldTypes,selectedInput[0].inputType)){
                    return true;
                }
            }
            return false;
        },
        getInputType(id){
            let selectedInput = "";
            this.inputTypesLov.forEach(inputType=>{
                if (inputType.typeId==id) {
                    selectedInput = inputType.inputType;
                }
            });
            return selectedInput
        },
        isDropdown(id){
            var selectedInput = this.inputTypesLov.filter(inputType=>{
                return (inputType.typeId == id)
            });
            if (selectedInput[0]) {
                if (selectedInput[0].inputType=='dropdown'){
                    return true;
                }
            }
            return false;
        },
        addDropdownOption(fieldRow){
            if (fieldRow.row.dropdownInput.trim().length != 0) {
                // Check if existing already
                var res = fieldRow.row.customDropdownOptions.filter(option=>{
                    return (option==fieldRow.row.dropdownInput)
                })
                if (res.length==0) {
                    fieldRow.row.customDropdownOptions.push(fieldRow.row.dropdownInput.trim());
                    // Reset input
                    fieldRow.row.dropdownInput = "";
                }
            } 
        },
        removeDropdownOption(fieldRow,optIdx){
            fieldRow.row.customDropdownOptions.splice(optIdx,1);
        },
        addFieldRow(){
            this.formFields.push({
                fieldLabel : "",
                fieldSubLabel : "",
                fieldGroupLabel : "",
                fieldGroupSubLabel: "",
                isRequired : true,
                fieldTypeIdFk : null,
                optionType : "",
                selectedPresetOptions : [],
                selectedPresetOption : "",
                customDropdownOptions : [],
                hasMultipleInputValue : false,
                dropdownInput : "",
                sequenceNumber : this.formFields.length,
                addedBy: this.profile.userId,
                formIdFk: this.savedFormData.formId
            });

            if (this.formFields.length > 0) {
                this.groupFields()
            }
        },
        groupFields() {
            let currFieldGroup=null;
            let newGroupedFields = [];
            this.groupedFields = []
            if ( this.formFields ) {
                if ( this.formFields.length > 0) {
                    this.formFields.forEach(field=>{                        
                        if (field.fieldGroupLabel==currFieldGroup && field.fieldGroupLabel!="") {
                            field.grpSequenceNumber = this.groupedFields[this.groupedFields.length-1].fields.length
                            this.groupedFields[this.groupedFields.length-1].fields.push(field)
                        }
                        else {
                            field.grpSequenceNumber = 0
                            this.currentGrp = {}
                            this.$set(this.currentGrp, 'fieldGroupName', field.fieldGroupLabel)
                            this.$set(this.currentGrp, 'fieldGroupSubLabel', field.fieldGroupSubLabel ? field.fieldGroupSubLabel : '')
                            this.$set(this.currentGrp, 'fields', [field])
                            this.$set(this.currentGrp, 'expanded', true)
                            if (field.fieldGroupLabel === '') {
                                this.$set(this.currentGrp, 'isField', true)
                            } else {
                                this.$set(this.currentGrp, 'isField', false)
                            }
                            this.groupedFields.push(this.currentGrp)
                        }
                        currFieldGroup = field.fieldGroupLabel;
                    });
                }
            } 
        },
        removeFieldRow(fieldRow, grp, spliceGroup){
            // Check if there's changes in the fields attributes;
            if (fieldRow.row.fieldLabel.trim().length > 0 || 
                fieldRow.row.fieldSubLabel.trim().length > 0 ||
                fieldRow.row.fieldGroupLabel.trim().length > 0 ||
                fieldRow.row.fieldGroupSubLabel.trim().length > 0 ||
                fieldRow.row.fieldTypeIdFk!=null || 
                fieldRow.row.selectedPresetOption.trim().length > 0 ||
                fieldRow.row.customDropdownOptions.length > 0) {

                var useLabel = 'this field'
                if (fieldRow.row.fieldLabel !== '') {
                    useLabel += ` (${fieldRow.row.fieldLabel})`
                }

                // Confirm Action
                this.$dialog.confirm({
                    title: 'Confirmation',
                    message: `This action will delete ${useLabel}. What do you want to do?`,
                    cancelText: "Keep Field",
                    confirmText: 'Proceed & Remove Field',
                    type: 'is-danger',
                    onConfirm: () => {
                        // this.formFields.splice(fieldRow.index,1);
                        if (!spliceGroup) {
                            // Delete field from group
                            this.groupedFields[grp.groupIdx].fields.splice(fieldRow.index, 1)
                        } else {
                            this.groupedFields.splice(grp.groupIdx, 1)
                        }
                    }
                })
                return false;
            }
            // this.formFields.splice(fieldRow.index,1);
            if (!spliceGroup) {
                // Delete field from group
                this.groupedFields[grp.groupIdx].fields.splice(fieldRow.index, 1)
            } else {
                this.groupedFields.splice(grp.groupIdx, 1)
            }
        },
        removeFieldNew(grp,currField) {
            /**
             * {
             *   fieldGroup: grp,
             *   groupIdx: grpIdx
             * },{
             *   index: fieldIdx,
             *   row: field
             * }
             * */

            /**
             * Check if field group or field
             */
            if (grp) {
                if (grp.fieldGroup.isField) {
                    /**
                     * If field, check if there are changes
                     */
                    this.removeFieldRow(currField, grp, true)
                } else {
                    if (grp.fieldGroup.fields.length === 1) {
                        /** Show additional message that removing this field will remove the whole group */
                        this.$dialog.confirm({
                            title: 'Confirmation',
                            message: 'Removing this field will also remove the whole group. What do you want to do?',
                            cancelText: "Keep Field",
                            confirmText: 'Remove Field',
                            type: 'is-danger',
                            onConfirm: () => {
                                // Delete from display/view
                                this.groupedFields.splice(grp.groupIdx, 1)
                                this.updateSequenceViaGroup()
                            }
                        })
                    } else {
                        this.removeFieldRow(currField, grp, false)
                    }
                }
            }
        },
        confirmDeleteFieldGroup(grp) {
            if (grp) {
                if (grp.fieldGroup.fields.length > 0) {
                    this.$dialog.confirm({
                        title: 'Confirmation',
                        message: 'This action will remove this field group and its field/s. What do you want to do?',
                        cancelText: "Keep Group & Fields",
                        confirmText: 'Remove Group & Fields',
                        type: 'is-danger',
                        onConfirm: () => {
                            this.deleteFieldGroup(grp)
                        }
                    })
                }
            }
        },
        deleteFieldGroup(grp){
            var newFieldsToDelete = []
            if (grp) {
                if (grp.fieldGroup.fields.length > 0) {
                    newFieldsToDelete = grp.fieldGroup.fields.filter(f => {
                        return !f.fieldId 
                    })
                }
            }
            if (newFieldsToDelete.length > 0) {
                this.groupedFields.splice(grp.groupIdx, 1)
                this.$notification.open({
                    duration: 5000,
                    message: 'Field group removed.',
                    position: 'is-bottom-left',
                    type: 'is-success'
                });
                this.updateSequenceViaGroup();
            }            
        },
        closeFieldMgt(){
            // Check if there's unsaved changes in form fields form
            var errorCnt = 0;
            this.formFields.forEach(field=>{
                if (field.fieldLabel.trim().length > 0 || 
                    field.fieldSubLabel.trim().length > 0 ||
                    field.fieldGroupLabel.trim().length > 0 ||
                    field.fieldTypeIdFk!=null || 
                    // field.selectedPresetOptions.length > 0 ||
                    field.selectedPresetOption.trim().length > 0 ||
                    field.customDropdownOptions.length > 0) {
                    errorCnt++;
                }
            });
            // Confirm Action
            if (errorCnt > 0) {
                this.$dialog.confirm({
                    title: 'Confirmation',
                    message: 'You have unsaved changes. Are you sure you want to leave this page?',
                    cancelText: "Stay",
                    confirmText: 'Leave Page',
                    type: 'is-warning',
                    onConfirm: () => {
                        this.$router.push({path:"/admin/forms?reportingYear="+this.selectedReportingYear});
                    }
                })
                return false;
            }
            // Go back to /forms
            this.$router.push({path:"/admin/forms?reportingYear="+this.selectedReportingYear});
        },
        saveFormFields(publish){
            var fieldsWithOpts = [];
            var fieldsWithoutOpts = [];
            var errorCnt = 0;
            this.formFields.forEach(field=>{
                if (field.fieldLabel=="") {
                    errorCnt++;
                }
                if (field.fieldTypeIdFk==null) {
                    errorCnt++;
                }
                if (field.fieldTypeIdFk!=null && field.fieldLabel!="") {
                    if (this.hasOptions(field.fieldTypeIdFk)) {
                        if (this.getInputType(field.fieldTypeIdFk)=='dropdown') {
                            if (field.selectedPresetOption.trim().length==0 && 
                                field.customDropdownOptions.length==0) {    
                                errorCnt++;
                            }
                        }
                        if (this.getInputType(field.fieldTypeIdFk)=='checkbox' || 
                            this.getInputType(field.fieldTypeIdFk)=='radio') {
                            if (field.customDropdownOptions.length==0) {    
                                errorCnt++;
                            }
                        }
                        if (field.selectedPresetOption.trim().length > 0) {
                            field.optionType = "preset";
                        }
                        else if (field.customDropdownOptions.length > 0) {
                            field.optionType = "custom";
                        }
                        fieldsWithOpts.push(field);
                    }
                    else {
                        field.optionType = "";
                        fieldsWithoutOpts.push(field);
                    }
                }
            });

            if (errorCnt > 0) {
                this.$notification.open({
                    duration: 5000,
                    message: 'Please check the required fields. <br/> <ul><li><strong>&nbsp;&nbsp;Field Label</strong></li><li><strong>&nbsp;&nbsp;Input Type</strong></li><li><strong>&nbsp;&nbsp;Dropdown Options <i>(*For dropdown input type)</i></strong></li></ul>',
                    position: 'is-bottom-left',
                    type: 'is-danger'
                });
                return false;
            }
            
            this.saveInputFields(fieldsWithoutOpts,fieldsWithOpts,publish);
        },
        saveInputFields(fields,dropdownFields,publish){
            FormFieldsApi.add(fields)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.saveDropdownFields(dropdownFields,publish);
                    }
                    else {
                        this.promptServerError({response},'FormFields.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormFields.add');
            })
        },
        saveDropdownFields(dropdownFields,publish){
            FormFieldsApi.addOne(dropdownFields)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (publish==1) {
                            this.publishForm();
                        }
                        else {
                            this.$notification.open({
                                duration: 3000,
                                message: 'Fields added!',
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });
                            this.areFormFieldsAdded = true;
                            this.activeStep++;
                            // this.$router.push({path:"/admin/forms?reportingYear="+this.selectedReportingYear});
                        }
                    }
                    else {
                        this.promptServerError({response},'FormFields.addOne')
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormFields.addOne');
            });
        },
        publishForm(){
            FormsApi.publish({
                formId : this.savedFormData.formId,
                updatedBy : this.profile.userId,
                action : 'publish'
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.$notification.open({
                            duration: 3000,
                            message: 'Form is published!',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        this.$router.push({path:"/admin/forms?reportingYear="+this.selectedReportingYear});
                    }
                    else {
                        this.promptServerError({response},'Form.publish');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Form.publish');
            })
        },
        updatedFormFileField(publish){

            FormsApi.updateFileField({
                enableFileUpload : this.enableFileUpload,
                formId : this.savedFormData.formId,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isUpdated) {
                            if (publish==1) {
                                this.publishForm();
                            }
                            else {
                                this.$notification.open({
                                    duration: 3000,
                                    message: 'Form saved!',
                                    position: 'is-bottom-left',
                                    type: 'is-success'
                                });
                                this.$router.push({path:"/admin/forms?reportingYear="+this.selectedReportingYear});
                            }
                        }
                    }
                    else {
                        this.promptServerError({response},'Form.updateFileField');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Form.updateFileField');
            })
        },
        switchOptionType(field,optType) {
            this.formFields[field.index].optionType = optType;
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        closeError(){
            this.globalError.show = false;
            this.globalError.message = "";
        },
        showError(msg){
            this.globalError.show = true;
            this.globalError.message = msg;
        },
        confirmDeleteAccess (data,level) {
            if (data) {
                var accessIds = [data.accessId]

                this.$dialog.confirm({
                    title: 'Delete Access Confirmation',
                    message: `This action will delete ${data[level]} (Id: ${data.accessId}) access to this form. If you're not sure with this transaction, please click 'Keep Access' and inform the site administrator. Otherwise, click 'Delete Access' to proceed.`,
                    cancelText: "Delete Access",
                    confirmText: "Keep Access",
                    type: 'is-danger',
                    onConfirm: () => {
                        
                    },
                    onCancel: ()=> {
                        this.deleteGroupAccess(accessIds)
                    }
                });
            }
        },
        deleteGroupAccess(accessIds) {
            if (!this.globalLoading) {
                this.globalLoading = this.$loading.open({
                    container: null
                })
            }
            FormAccessApi.delete({
                accessIds
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.globalLoading.close();
                        this.$notification.open({
                            duration: 5000,
                            message: 'Form access updated. Removed some access.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        // To get updated access for the next step
                        this.getForm();
                    }
                    else {
                        this.globalLoading.close();
                        if (response.data.error.hasOwnProperty('code') &&
                            response.data.error.code==220) {
                            this.$dialog.alert({
                                title: 'Error: Unable to delete',
                                message: response.data.error.message,
                                type: 'is-danger'
                            });
                            return false;
                        }
                        this.promptServerError({response},'FormAccess.delete');
                    }
                }
            })
            .catch(error=>{
                this.globalLoading.close();
                this.promptServerError(error,'FormAccess.delete');
            })
        },
        numSelected (repGroup) {
            /** For new implemention of access */
            var repEntsSelected = []
            var repUnits = []
            if (this.isGroupSelected(repGroup)) {                
                if (repGroup.repEntityIds.length > 0) {
                    repGroup.repEntityIds.forEach(rgre => {
                        if (ArrayUtil.inArray(this.newFormData.repEntityAccess,rgre)) {
                            repEntsSelected.push(rgre)
                        }
                    })
                }
                if (repGroup.hasUnits) {
                    repGroup.repUnitIds.forEach(rgru => {
                        if (ArrayUtil.inArray(this.newFormData.repUnitAccess,rgru)) {
                            repUnits.push(rgru)
                        }
                    })
                }
                var str = ''
                var total = repEntsSelected.length + repUnits.length
                if (repEntsSelected.length > 0) {
                    str += `${repEntsSelected.length} `
                    if (repEntsSelected.length > 1) {
                        str += 'Entities'
                    } else {
                        str += 'Entity'
                    }
                }
                if (repUnits.length > 0) {
                    if (str != '') {
                        str += '; '
                    }
                    str += ` ${repUnits.length} Unit`
                    if (repUnits.length > 1) {
                        str += 's'
                    }
                }
                if (total === 0) {
                    return 'None selected'
                }
                return `${total} selected (${str})`
            }
            return 'None selected'
        },
        showRepGroupSelection (repGroup) {
            this.openedRepGroup = repGroup
        },
        changePage(repGroup,mode) {
            if (mode === 'next') {
                if (repGroup.currentPage <= repGroup.pagedData.length) {
                    repGroup.currentPage++
                }
            } else {
                if (repGroup.currentPage > 0) {
                    repGroup.currentPage--
                } 
            }
        },
        doSearchEntity(repGroup) {
            if (!repGroup.keywordFilter || (repGroup.keywordFilter && repGroup.keywordFilter.trim().length === 0))  {
                return false
            }
            var regExp = new RegExp(repGroup.keywordFilter,'i')
            var result = []
            if (repGroup.reportingEntities.length > 0) {
                result = repGroup.reportingEntities.filter(re => {
                    return re.reportingEntity.match(regExp)
                })
            }
            repGroup.pagedData = ArrayUtil.paginate(result, this.pageSize)
            repGroup.numPageItems = ArrayUtil.pageItems(repGroup.pagedData)
            if (repGroup.pagedData.length > 0) {
                repGroup.currentPage = 1
            } else {
                repGroup.currentPage = 0
            }
        },
        resetSearch (repGroup) {
            repGroup.keywordFilter = ''
            var result = []
            if (repGroup.reportingEntities.length > 0) {
                result = ArrayUtil.paginate(repGroup.reportingEntities, this.pageSize)
            }
            repGroup.pagedData = result
            repGroup.numPageItems = ArrayUtil.pageItems(repGroup.pagedData)
            if (repGroup.pagedData.length > 0) {
                repGroup.currentPage = 1
            } else {
                repGroup.currentPage = 0
            }
        },
        checkSearch(evt, repGroup) {
            this.doSearchEntity(repGroup)
        },
        addToPosition(currField,position) {
            var newFieldData = {
                fieldLabel : "",
                fieldSubLabel : "",
                fieldGroupLabel : "",
                isRequired : true,
                fieldTypeIdFk : null,
                optionType : "",
                selectedPresetOption : "",
                customDropdownOptions : [],
                hasMultipleInputValue : false,
                dropdownInput : "",
                sequenceNumber : null,
                addedBy: this.profile.userId,
                formIdFk: this.savedFormData.formId
            }
            /** If before, new field index is same with currField.index */
            if (position === 'before') {
                newFieldData.sequenceNumber = currField.index
            } else {
                /** If 'after', new field index is currField.index + 1 */
                newFieldData.sequenceNumber = currField.index + 1
            }
            
            if (newFieldData.sequenceNumber === this.formFields.length) {
                this.addFieldRow()
            } else {
                this.addFieldRowToPos(newFieldData, newFieldData.sequenceNumber)
            }
        },
        addFieldRowToPos(newFieldData, idx) {
            var updatedFormFields = []
            this.formFields.forEach((field,fieldIdx) => {
                if (fieldIdx === idx ) {
                    updatedFormFields.push(newFieldData)
                }
                field.sequenceNumber = fieldIdx + 1
                updatedFormFields.push(field)
            })
            this.formFields = updatedFormFields

            this.updateFieldSequence()
        },
        updateFieldSequence () {
            if (this.formFields.length > 0) {
                this.formFields.forEach((field,index)=>{
                    field.sequenceNumber = index
                });
            }
        },
        addToPositionNew(grp, currField, position, isGroup) {
            /** 
             * type (String) - can be 'field' or 'group'
             * indicates what will be added
            */
            var newFieldData = {
                fieldLabel : "",
                fieldSubLabel : "",
                fieldGroupLabel : "",
                fieldGroupSubLabel: "",
                isRequired : true,
                fieldTypeIdFk : null,
                optionType : "",
                selectedPresetOption : "",
                customDropdownOptions : [],
                hasMultipleInputValue : false,
                dropdownInput : "",
                sequenceNumber : null,
                grpSequenceNumber: null,
                addedBy: this.profile.userId,
                formIdFk: this.savedFormData.formId
            }

            /** 
             * Check if group is not empty; field is added to group
             * 
             * Apply group label and/or group sub label
             * 
             * Check position: after, before, null
             * if position is after or before, check reference field (currField)
             * 
             * if position is null - add as last field of the group
             * 
             * if position is before/after - get index of reference field
             * - set sequence number of new field
             * 
             * Add new field to group
             * Add new field to formFields
             * 
             * Loop through formFields to assign new sequenceNumbers 
             */

            if (!grp) {
                /** Add field and group at the end */
                newFieldData.grpSequenceNumber = 0
                newFieldData.sequenceNumber = this.formFields.length
                this.newFieldAndGroup(newFieldData, true,  {
                    newFieldSequenceNum: newFieldData.sequenceNumber,
                    newGroupIndex: null,
                    isGroup: isGroup
                })
            } else {
                /**
                 * If add is triggered from:
                 * 
                 * Field group options (field, group)
                 * Field options (field, group)
                 * Field group add action at the bottom (field)
                  */
                if (!currField) {
                    /** To add outside the group */
                    if (!position) {
                        /** 
                         * Add last field/group to group 
                         * When 'Add new field to group' to group is clicked
                        */
                        /** Add field and group at the end */
                        if (grp.fieldGroup.fieldGroupName && grp.fieldGroup.fieldGroupName !== '') {
                            newFieldData.fieldGroupLabel = grp.fieldGroup.fieldGroupName
                        }
                        if (grp.fieldGroup.fieldGroupSubLabel && grp.fieldGroup.fieldGroupSubLabel !== '') {
                            newFieldData.fieldGroupSubLabel = grp.fieldGroup.fieldGroupSubLabel
                        }                        
                        newFieldData.grpSequenceNumber = grp.fieldGroup.length
                        this.groupedFields[grp.groupIdx].fields.push(newFieldData)                        
                        /** Update form fields array */
                        this.updateSequenceViaGroup() 
                    } else {
                        /** 
                         * Add field or field group from field group menu option
                         * */
                        var newGroupIdx = null
                        var isLast = false
                        newFieldData.grpSequenceNumber = 0
                        if (position === 'before') {
                            newFieldData.sequenceNumber = this.groupedFields[grp.groupIdx].fields[0].sequenceNumber
                            newGroupIdx = grp.groupIdx 
                        } else {
                            newFieldData.sequenceNumber = this.groupedFields[grp.groupIdx].fields[this.groupedFields[grp.groupIdx].fields.length-1].sequenceNumber + 1
                            newGroupIdx = grp.groupIdx + 1
                        }
                        if (newGroupIdx === this.groupedFields.length) {
                            isLast = true
                        }
                        this.newFieldAndGroup(newFieldData, isLast, {
                            newFieldSequenceNum: newFieldData.sequenceNumber,
                            newGroupIndex: newGroupIdx,
                            isGroup: isGroup
                        })
                    }
                } else {
                    /** Triggered from field (add) menu */

                    /** 
                     * Check if add is triggered from individual field (grp.fieldGroup.isField) or 
                     * from field within group */

                    /** 
                     * If triggered from field without group name */
                    if (grp.fieldGroup && grp.fieldGroup.isField) {
                        var newGroupIdx = null
                        var isLast = false
                        newFieldData.grpSequenceNumber = 0
                        if (position === 'before') {
                            newFieldData.sequenceNumber = this.groupedFields[grp.groupIdx].fields[0].sequenceNumber
                            newGroupIdx = grp.groupIdx 
                        } else {
                            newFieldData.sequenceNumber = this.groupedFields[grp.groupIdx].fields[this.groupedFields[grp.groupIdx].fields.length-1].sequenceNumber + 1
                            newGroupIdx = grp.groupIdx + 1
                        }
                        if (newGroupIdx === this.groupedFields.length) {
                            isLast = true
                        }
                        this.newFieldAndGroup(newFieldData, isLast, {
                            newFieldSequenceNum: newFieldData.sequenceNumber,
                            newGroupIndex: newGroupIdx,
                            isGroup: isGroup
                        })
                    } else {
                        /** 
                         * If triggered from field in a field group
                         * */
                        if (grp.fieldGroup.fieldGroupName && grp.fieldGroup.fieldGroupName !== '') {
                            newFieldData.fieldGroupLabel = grp.fieldGroup.fieldGroupName
                        }
                        if (grp.fieldGroup.fieldGroupSubLabel && grp.fieldGroup.fieldGroupSubLabel !== '') {
                            newFieldData.fieldGroupSubLabel = grp.fieldGroup.fieldGroupSubLabel
                        } 
                        if (position === 'before') {
                            newFieldData.grpSequenceNumber = currField.row.grpSequenceNumber
                            newFieldData.sequenceNumber = currField.index 
                        } else {
                            newFieldData.grpSequenceNumber = currField.row.grpSequenceNumber + 1
                            newFieldData.sequenceNumber = currField.index + 1
                        }
                        if (newFieldData.grpSequenceNumber === this.groupedFields[grp.groupIdx].fields.length) {
                            this.groupedFields[grp.groupIdx].fields.push(newFieldData)
                        } else {
                            var updatedFieldsInGroup = []
                            this.groupedFields[grp.groupIdx].fields.forEach((gfield,gfieldIdx) => {
                                if (gfieldIdx === newFieldData.grpSequenceNumber ) {
                                    updatedFieldsInGroup.push(newFieldData)
                                }
                                updatedFieldsInGroup.push(gfield)
                            })
                            this.groupedFields[grp.groupIdx].fields = updatedFieldsInGroup
                        }

                        /** Update field sequence */
                        this.groupedFields[grp.groupIdx].fields.forEach((gfield,gfieldIdx) => {
                            gfield.grpSequenceNumber = gfieldIdx
                        })
                                            
                        /** Update form fields array */
                        this.updateSequenceViaGroup() 
                    }
                }
            }
        },
        newFieldAndGroup(newFieldData, addToEnd, seqNumData) {
            /** 
             * When (Add Field) is clicked
             * Adds field at the end
             * 
             * Create new field group with empty group name */
            this.currentGrp = {}
            this.$set(this.currentGrp, 'fieldGroupName', '')
            this.$set(this.currentGrp, 'fieldGroupSubLabel', '')
            this.$set(this.currentGrp, 'fields', [newFieldData])
            this.$set(this.currentGrp, 'expanded', true)
            if (seqNumData.isGroup) {
                this.$set(this.currentGrp, 'isField', false)
            } else {
                this.$set(this.currentGrp, 'isField', true)
            }            
            
            if (addToEnd) {
                /** Push new group to last */
                this.groupedFields.push(this.currentGrp)
                /** Push new field to the last */
                this.formFields.push(newFieldData)

                /** Update form fields array */
                this.updateSequenceViaGroup()  
            } else {
                /** Insert new group to position */
                var updatedFieldGroup = []
                this.groupedFields.forEach((grp,grpIdx) => {
                    if (grpIdx === seqNumData.newGroupIndex ) {
                        updatedFieldGroup.push(this.currentGrp)
                    }
                    updatedFieldGroup.push(grp)
                })
                this.groupedFields = updatedFieldGroup
                /** Add new field to the new position */
                this.addFieldRowToPos(newFieldData, seqNumData.newFieldSequenceNum)
            }
        },
        updateSequenceViaGroup () {
            var newFormFields = []
            if (this.groupedFields.length > 0) {
                this.groupedFields.forEach(grp => {
                    if (grp.fields.length > 0) {
                        grp.fields.forEach(field => {
                            field.sequenceNumber = newFormFields.length
                            newFormFields.push(field)
                        })
                    }
                })
            }
            this.formFields = newFormFields
        },
        toggleAllGroups () {
            this.allExpanded = !this.allExpanded 
            if (this.groupedFields.length > 0) {
                this.groupedFields.forEach(grp => {
                    if (grp.isField === false) {
                        grp.expanded = this.allExpanded
                    }
                })
            }
        },
        updateGroupDetails: _.debounce((currentGroup) => {
            if (currentGroup.fields.length > 0) {
                var grpName = ''
                var grpSubLabel = ''
                if (currentGroup.fieldGroupName !== '') {
                    grpName = currentGroup.fieldGroupName
                }
                if (currentGroup.fieldGroupSubLabel !== '') {
                    grpSubLabel = currentGroup.fieldGroupSubLabel
                }
                currentGroup.fields.forEach(field => {
                    field.fieldGroupLabel = grpName
                    field.fieldGroupSubLabel = grpSubLabel
                })
            }
        }, 2000)
    }
}
</script>

<template>
    <section>
        <div class="base-box--sidepadded">
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li>
                        <a 
                            v-if="selectedReportingYear"
                            v-bind:href="'#/admin/forms?reportingYear='+selectedReportingYear">
                            Forms
                        </a>
                    </li>
                    <li class="is-active"><a href="#" aria-current="page">Add</a></li>
                </ul>
            </nav>
        </div>

        <p class="subtitle page-title">Add Form</p>

        <section class="base-box--loading"
            v-if="isLoading">
            <b-loading 
                v-bind:is-full-page="isFullPage" 
                v-bind:active.sync="isLoading"
                >
                <b-icon
                    pack="fas"
                    icon="sync-alt"
                    size="is-medium"
                    custom-class="fa-spin">
                </b-icon>
                &nbsp;&nbsp;&nbsp;
                <span class="title is-5">Loading form</span>
            </b-loading>
        </section>

        <div class="section no-padd"
            style="padding-left:1.5rem !important;padding-bottom:1rem !important;">
            <div class="has-text-left is-italic">
                Fields marked with * are mandatory.
            </div>

            <div class="notification is-danger"
                v-if="globalError.show">
                <button class="delete"
                    type="button"
                    v-on:click="closeError"></button>
                <p>{{globalError.message}}</p>
            </div>
        </div>

        <div class="section no-padd--top app-view"
            v-if="!isLoading">

            <b-steps v-model="activeStep" 
                v-bind:animated="true"
                v-bind:has-navigation="false"
                size="is-small">
                
                <!-- Step 1 : Name & Access -->
                <b-step-item 
                    label="Add Name and Access"
                    v-bind:type="{'is-success': isFormNameAccessSuccess}">

                    <div class="box">
                        <!-- <p class="title is-4">Form Name and Access</p> -->
                        <div class="new-form-details-box">

                            <b-field
                                :type="{
                                    'is-danger':!selectedReportingYear
                                }"
                                label="*Reporting Year">
                                <b-select placeholder="Choose reporting year"
                                    v-model="selectedReportingYear"
                                    required>
                                    <option
                                        v-for="(year,yearIdx) in reportingYearLov"
                                        v-bind:key="yearIdx"
                                        v-bind:value="year">
                                        {{year}}
                                    </option>
                                </b-select>
                            </b-field> <br/>

                            <b-field label="*Enter Form Name"
                                v-bind:type="{
                                    'is-danger':!newFormData.formName,
                                    'is-info':formNameInvalid==true,
                                    'is-success':formNameInvalid==false
                                }"
                                v-bind:message="formNameErrorMessage">
                                <b-input
                                    v-model="newFormData.formName" 
                                    value=""
                                    maxlength="50"
                                    required
                                    v-on:input="checkFormName"
                                    v-bind:loading="formNamePromise"></b-input>
                            </b-field>


                            <div class="field">
                                <div class="field-label is-normal has-text-left">
                                    <label class="label">*Choose who has access to this form</label>
                                </div>
                                <div class="field-body" 
                                    style="display:block">
                                    <!-- <div class="columns is-multiline is-mobile">
                                        <div class="column is-4" 
                                            v-for="(repGroup,repGroupIdx) in repGroupLov"
                                            v-bind:key="repGroupIdx">

                                            <div class="box">
                                            
                                                <p class="control">
                                                    <b-checkbox 
                                                        v-model="newFormData.repGroupAccess"
                                                        v-bind:native-value="repGroup.repGroupId">
                                                        <span class="subtitle is-5 has-text-weight-medium">{{repGroup.reportingGroup}}</span>
                                                    </b-checkbox>
                                                </p>

                                                <div v-if="repGroup.reportingEntities.length > 0 && isGroupSelected(repGroup)"
                                                    class="form-access-grp__sub--entity">

                                                    <span class="subtitle is-6 has-text-weight-semibold">
                                                        <span v-if="repGroup.reportingGroup!=govAgencyGroup">ALL</span> 
                                                        {{repGroup.reportingGroup}}
                                                    </span>
                                                    <span class="is-italic has-text-info"
                                                        v-if="repGroup.reportingGroup!=govAgencyGroup"><br/>*Uncheck to exclude an entity</span><br/>

                                                    <div class="field"
                                                        v-for="(entity,entityIdx) in repGroup.reportingEntities"
                                                        v-bind:key="entityIdx">
                                                        
                                                        <p class="control">
                                                            <b-checkbox 
                                                                v-model="newFormData.repEntityAccess"
                                                                v-bind:native-value="entity.repEntityId">
                                                                {{entity.reportingEntity}}
                                                            </b-checkbox>
                                                        </p>

                                                        <div v-if="entity.reportingUnits.length > 0 && isEntitySelected(entity)"
                                                            class="form-access-grp__sub--unit">

                                                            <span class="subtitle is-6 has-text-weight-semibold">Reporting Units</span><br/>
                                                            <span class="is-italic has-text-info">*Uncheck to exclude a unit</span><br/>

                                                            <div class="field"
                                                                v-for="(repUnit,repUnitIdx) in entity.reportingUnits"
                                                                v-bind:key="repUnitIdx">
                                                                <p class="control">
                                                                    <b-checkbox 
                                                                        v-model="newFormData.repUnitAccess"
                                                                        v-bind:native-value="repUnit.repUnitId">
                                                                        {{repUnit.reportingUnit}}
                                                                    </b-checkbox>
                                                                </p>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    

                                                </div>

                                            </div>
                                        </div>
                                    </div> -->
                                    
                                    <!-- New implementation -->
                                    <div v-for="(repGroup,repGroupIdx) in repGroupLov"
                                        v-bind:key="repGroupIdx"
                                        class="box"
                                        style="padding:0.4rem;margin-bottom:0.3rem">
                                        
                                        <div class="rg-header"
                                            style="padding:0.3rem;padding-left:0.6rem">
                                            <b-field grouped>
                                                <b-field 
                                                        style="padding-top:0.1rem">
                                                    <b-checkbox 
                                                        v-model="newFormData.repGroupAccess"
                                                        v-bind:native-value="repGroup.repGroupId"
                                                        v-on:change.native="checkAccess(0,repGroup)">
                                                        <span class="has-text-weight-medium">{{repGroup.reportingGroup}}</span>
                                                    </b-checkbox>
                                                </b-field>
                                                <p class="control">
                                                    <button 
                                                        class="button is-light is-italic has-text-info is-small"
                                                        :disabled="!isGroupSelected(repGroup)"
                                                        @click="repGroup.expanded = !repGroup.expanded">
                                                        {{numSelected(repGroup)}}
                                                    </button>
                                                </p>
                                                <p class="control">
                                                    <button 
                                                        type="button"
                                                        class="button is-white is-rounded is-small"
                                                        :disabled="!isGroupSelected(repGroup)"
                                                        @click="repGroup.expanded = !repGroup.expanded">
                                                        <span class="icon">
                                                            <i class="fas fa-caret-up"
                                                                v-if="repGroup.expanded"></i>
                                                            <i class="fas fa-caret-down"
                                                                v-else></i>
                                                        </span>
                                                    </button>
                                                </p>
                                                
                                            </b-field>
                                        </div>
                                        
                                        <div class="rg-items-body"
                                            v-if="repGroup.expanded">
                                            <hr 
                                                v-if="repGroup.reportingEntities.length > 5"/>

                                            <div class="rg-items-filter"
                                                v-if="repGroup.reportingEntities.length > 5"
                                                style="padding-left:0.7rem">
                                                <b-field grouped>
                                                    <b-field>
                                                        <b-input placeholder="Enter keyword"
                                                            size="is-small"
                                                            type="search"
                                                            v-model="repGroup.keywordFilter"
                                                            v-on:keyup.native.13="checkSearch($event,repGroup)">
                                                        </b-input>
                                                        <p class="control">
                                                            <button class="button is-info is-small"
                                                                @click="doSearchEntity(repGroup)">
                                                                Search Entity
                                                            </button>
                                                        </p>
                                                    </b-field>    
                                                    <b-field>                                            
                                                        <p class="control">
                                                            <button class="button is-link is-small"
                                                                @click="resetSearch(repGroup)">
                                                                Clear Search
                                                            </button>
                                                        </p>
                                                    </b-field>
                                                    <b-field
                                                        style="padding-top:0.15rem"
                                                        v-if="repGroup.hasUnits">
                                                        <b-switch
                                                            size="is-small"
                                                            type="is-info"
                                                            v-model="repGroup.showUnits">
                                                            Show Reporting Units
                                                        </b-switch>
                                                    </b-field>
                                                    <div class="separator-v"></div>
                                                    <div class="field is-grouped">
                                                        <p class="control">
                                                            <span style="font-size:12px">{{ ( (repGroup.currentPage-1) * pageSize ) + 1 }}-{{ (( (repGroup.currentPage-1) * pageSize ) ) + repGroup.pagedData[repGroup.currentPage-1].length}} of {{repGroup.numPageItems}}</span>
                                                        </p>
                                                        <p class="control">
                                                            <button class="button is-link is-rounded is-small"
                                                                :disabled="repGroup.currentPage-1 == 0"
                                                                @click="changePage(repGroup,'prev')">
                                                            Prev
                                                            </button>
                                                        </p>
                                                        <p class="control">
                                                            <button class="button is-rounded is-small"
                                                                :disabled="repGroup.currentPage == repGroup.pagedData.length"
                                                                @click="changePage(repGroup,'next')">
                                                            Next
                                                            </button>
                                                        </p>
                                                    </div>
                                                </b-field>
                                            </div>
                                            
                                            <hr />
                                            <div class="rg-items-body"
                                                style="padding:1rem">

                                                <div class="columns is-mobile is-multiline"
                                                    v-if="repGroup.pagedData.length > 0">
                                                    <div class="column is-one-third"
                                                        v-for="(entity,entityIdx) in repGroup.pagedData[repGroup.currentPage-1]"
                                                        v-bind:key="entityIdx"
                                                        style="padding:0.4rem">
                                                            
                                                        <b-field>
                                                            <b-checkbox 
                                                                size="is-small"
                                                                v-model="newFormData.repEntityAccess"
                                                                v-bind:native-value="entity.repEntityId"
                                                                v-on:change.native="checkAccess(1,repGroup,entity)">
                                                                {{entity.reportingEntity}} 
                                                                <span 
                                                                    v-if="entity.reportingUnits.length > 0">({{entity.reportingUnits.length}})</span>
                                                            </b-checkbox>
                                                        </b-field>

                                                        <div v-if="entity.reportingUnits.length > 0 && repGroup.showUnits">

                                                            <div class="field"
                                                                v-for="(repUnit,repUnitIdx) in entity.reportingUnits"
                                                                v-bind:key="repUnitIdx">
                                                                <p class="control">
                                                                    <b-checkbox 
                                                                        size="is-small"
                                                                        type="is-info"
                                                                        v-model="newFormData.repUnitAccess"
                                                                        v-bind:native-value="repUnit.repUnitId">
                                                                        {{repUnit.reportingUnit}}
                                                                    </b-checkbox>
                                                                </p>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="field"
                                v-if="hasGovAccess(newFormData.reportingGroupAccess)">
                                <div class="field-label is-normal has-text-left">
                                    <label class="label">Reporting Entity Access</label>
                                </div>
                                <div class="field-body">
                                    <div class="block">
                                        <div class="field"
                                            v-for="(govEntity,govEntityIdx) in reportingGroupsLov[0].reportingEntities"
                                            v-bind:key="govEntityIdx">
                                            <p class="control">
                                                <b-checkbox 
                                                    v-model="newFormData.reportingEntityAccess"
                                                    v-bind:native-value="govEntity.reportingEntity">
                                                    {{govEntity.reportingEntity}}
                                                </b-checkbox>
                                            </p>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-label is-normal has-text-left">
                                    <label class="label">Form Submission Type</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <p class="control">
                                            <b-select placeholder="Select one"
                                                v-model="newFormData.formSubmissionType">
                                                <option value="Single">Single</option>
                                                <option value="Multiple">Multiple</option>
                                            </b-select>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-label is-normal has-text-left">
                                    <label class="label">Form Active</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <p class="control">
                                            <b-checkbox v-model="newFormData.isActive">
                                                {{newFormData.isActive==true ? 'Yes' : 'No'}}
                                            </b-checkbox>
                                        </p>
                                    </div>
                                </div>
                            </div> -->  
                        </div>
                        <div class="is-divider"></div>
                        <div class="buttons">
                            <a class="button"
                                v-on:click="cancel">
                                Cancel
                            </a>
                            <a class="button is-success"
                                v-bind:class="{'is-loading':addNewFormPromise==true}"
                                v-on:click="addNewFormData">
                                <!-- v-bind:disabled="!isFormValid" -->
                                Save & Proceed 
                            </a>
                        </div>
                    </div>
                    <!-- End: Name & Access -->
                </b-step-item>
                
                <!-- Step 2: Access Restriction (formId and accessIds are created) -->
                <b-step-item 
                    label="Form Setting per Access"
                    v-bind:type="{'is-success': isFormAccessSettingSuccess}">

                    <div>

                        <!-- New implementation -->
                        <div v-for="(group,groupIdx) in groupedFormAccess"
                            v-bind:key="groupIdx"
                            class="box"
                            style="padding:0.4rem;margin-bottom:0.3rem">
                            
                            <div class="rg-header"
                                style="padding:0.1rem;padding-left:0.6rem;padding-top:0.4rem">
                                <b-field grouped>
                                    <p class="control">
                                        <button 
                                            type="button"
                                            class="button is-white is-rounded is-small"
                                            @click="group.expanded = !group.expanded">
                                            <span class="icon">
                                                <i class="fas fa-caret-up"
                                                    v-if="group.expanded"></i>
                                                <i class="fas fa-caret-down"
                                                    v-else></i>
                                            </span>
                                        </button>
                                    </p>
                                    <b-field 
                                            style="padding-top:0.1rem">
                                        <p class="has-text-weight-medium">{{group.reportingGroup}} ({{group.reportingEntities.length}})</p>
                                    </b-field>
                                    <div class="separator-v"></div>
                                    <b-field>
                                        <b-select placeholder="Change Submission Type"
                                            size="is-small"
                                            v-model="group.formSubmissionType"
                                            v-on:change.native="selectSubmissionType(group,null)">
                                            <option
                                                value="Single">
                                                All Single
                                            </option>
                                            <option
                                                value="Multiple">
                                                All Multiple
                                            </option>
                                        </b-select>
                                    </b-field>
                                    <b-field>
                                        <b-select 
                                            v-model="group.displayOption"
                                            size="is-small"
                                            placeholder="Change Display"
                                            v-on:change.native="selectDisplayOption(group,null)">
                                            <option
                                                value="List">
                                                All List
                                            </option>
                                            <option
                                                value="Table">
                                                All Table
                                            </option>
                                        </b-select>
                                    </b-field>
                                    <div class="field">
                                        <small class="has-text-weight-normal">Access Id: {{group.accessId}}</small>                                      
                                    </div>
                                    <b-field
                                        v-if="profile && profile.fullName === 'System Admin'"
                                        class="sysad-field">
                                        <a class="button is-light is-small sysad-field-delete"
                                            type="button"
                                            title="Delete Reporing Entity Access"
                                            v-on:click="confirmDeleteAccess(group,'reportingGroup')">
                                            <span class="icon">
                                                <i class="fas fa-trash"></i>
                                            </span>
                                        </a>
                                    </b-field>
                                </b-field>
                            </div>
                            
                            <div class="rg-items-body"
                                v-if="group.expanded">
                                <hr 
                                    v-if="group.reportingEntities.length > 5"/>

                                <div class="rg-items-filter"
                                    v-if="group.reportingEntities.length > 5"
                                    style="padding-left:0.7rem">
                                    <b-field grouped>
                                        <b-field>
                                            <b-input placeholder="Enter keyword"
                                                size="is-small"
                                                type="search"
                                                v-model="group.keywordFilter"
                                                v-on:keyup.native.13="checkSearch($event,group)">
                                            </b-input>
                                            <p class="control">
                                                <button class="button is-info is-small"
                                                    @click="doSearchEntity(group)">
                                                    Search Entity
                                                </button>
                                            </p>
                                        </b-field>    
                                        <b-field>                                            
                                            <p class="control">
                                                <button class="button is-link is-small"
                                                    @click="resetSearch(group)">
                                                    Clear Search
                                                </button>
                                            </p>
                                        </b-field>
                                        <b-field
                                            style="padding-top:0.15rem"
                                            v-if="group.hasUnits">
                                            <b-switch
                                                size="is-small"
                                                type="is-info"
                                                v-model="group.showUnits">
                                                Show Reporting Units
                                            </b-switch>
                                        </b-field>
                                        <div class="separator-v"></div>
                                        <div class="field is-grouped">
                                            <p class="control">
                                                <span style="font-size:12px">{{ ( (group.currentPage-1) * pageSize ) + 1 }}-{{ (( (group.currentPage-1) * pageSize ) ) + group.pagedData[group.currentPage-1].length}} of {{group.numPageItems}}</span>
                                            </p>
                                            <p class="control">
                                                <button class="button is-link is-rounded is-small"
                                                    :disabled="group.currentPage-1 == 0"
                                                    @click="changePage(group,'prev')">
                                                Prev
                                                </button>
                                            </p>
                                            <p class="control">
                                                <button class="button is-rounded is-small"
                                                    :disabled="group.currentPage == group.pagedData.length"
                                                    @click="changePage(group,'next')">
                                                Next
                                                </button>
                                            </p>
                                        </div>
                                    </b-field>
                                </div>
                                
                                <hr 
                                    style="margin:0px"/>
                                <div class="rg-items-body"
                                    style="padding:1rem">

                                    <div class="columns is-mobile is-multiline"
                                        v-if="group.pagedData.length > 0">
                                        <div class="column"
                                            :class="group.pagedData[group.currentPage-1].length > 1 ? 'is-one-third' : 'is-full'"
                                            v-for="(entity,entityIdx) in group.pagedData[group.currentPage-1]"
                                            v-bind:key="entityIdx"
                                            style="padding:0.4rem">
                                            <b-field grouped>
                                                <b-field class="sysad-field"
                                                    v-if="profile && profile.fullName === 'System Admin'">
                                                    <a class="button is-light is-small sysad-field-delete"
                                                        type="button"
                                                        title="Delete Reporing Entity Access"
                                                        v-on:click="confirmDeleteAccess(entity,'reportingEntity')">
                                                        <span class="icon">
                                                            <i class="fas fa-trash"></i>
                                                        </span>
                                                    </a>
                                                </b-field>
                                                <b-field>
                                                    <b-select placeholder="Submission Type"
                                                        size="is-small"
                                                        v-model="entity.formSubmissionType"
                                                        v-on:change.native="selectSubmissionType(entity,null)">
                                                        <option
                                                            value="Single">
                                                            Single
                                                        </option>
                                                        <option
                                                            value="Multiple">
                                                            Multiple
                                                        </option>
                                                    </b-select>
                                                </b-field>
                                                <b-field>
                                                    <b-select 
                                                        size="is-small"
                                                        placeholder="Display"
                                                        v-model="entity.displayOption"
                                                        v-on:change.native="selectDisplayOption(entity,null)">
                                                        <option
                                                            value="List">
                                                            List
                                                        </option>
                                                        <option
                                                            value="Table">
                                                            Table
                                                        </option>
                                                    </b-select>
                                                </b-field>

                                                <div style="font-size:12px;margin-top:0.26rem"
                                                    :title="`${entity.reportingEntity} (Id:${entity.accessId})`">
                                                    {{entity.reportingEntity}}
                                                    <span v-if="entity.reportingUnits.length > 0">({{entity.reportingUnits.length}})</span>
                                                </div>
                                                
                                            </b-field>

                                            <div v-if="entity.reportingUnits.length > 0 && group.showUnits">
                                                <div 
                                                    v-for="(repUnit,repUnitIdx) in entity.reportingUnits"
                                                    v-bind:key="repUnitIdx">
                                                    <b-field grouped>
                                                        <b-field class="sysad-field"
                                                            v-if="profile && profile.fullName === 'System Admin'">
                                                            <a class="button is-light is-small sysad-field-delete"
                                                                type="button"
                                                                title="Delete Reporing Unit Access"
                                                                v-on:click="confirmDeleteAccess(repUnit,'reportingUnit')">
                                                                <span class="icon">
                                                                    <i class="fas fa-trash"></i>
                                                                </span>
                                                            </a>
                                                        </b-field>
                                                        <b-field>
                                                            <b-select placeholder="Submission Type"
                                                                size="is-small"
                                                                v-model="repUnit.formSubmissionType"
                                                                v-on:change.native="selectSubmissionType(repUnit,null)">
                                                                <option
                                                                    value="Single">
                                                                    Single
                                                                </option>
                                                                <option
                                                                    value="Multiple">
                                                                    Multiple
                                                                </option>
                                                            </b-select>
                                                        </b-field>
                                                        <b-field>
                                                            <b-select 
                                                                size="is-small"
                                                                placeholder="Display"
                                                                v-model="repUnit.displayOption"
                                                                v-on:change.native="selectDisplayOption(repUnit,null)">
                                                                <option
                                                                    value="List">
                                                                    List
                                                                </option>
                                                                <option
                                                                    value="Table">
                                                                    Table
                                                                </option>
                                                            </b-select>
                                                        </b-field>

                                                        <div style="font-size:12px;margin-top:0.26rem;"
                                                            class="is-italic"
                                                            :title="`${repUnit.reportingUnit} (Id:${repUnit.accessId})`">
                                                            {{repUnit.reportingUnit}}
                                                        </div>
                                                    </b-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="is-divider"></div>
                        <div class="buttons">
                            <a class="button"
                                v-on:click="saveFormSetting(0)">
                                Save & Close
                            </a>
                            <a class="button is-success"
                                v-on:click="saveFormSetting(1)">
                                Save & Proceed 
                            </a>
                        </div>
                    </div>
                </b-step-item>

                <!-- Step 3: Form Fields (formId) -->
                <b-step-item 
                    label="Add Fields"
                    v-bind:type="{'is-success': areFormFieldsAdded}">
                    
                    <div class="box form-fields-box">
                        
                        <div v-if="hasFieldGroups">
                            <a class="button is-light is-small"
                                v-on:click="toggleAllGroups">
                                <span>{{collapseAllLabel}}</span>
                                <span class="icon">
                                    <i class="fas fa-caret-up"
                                        v-if="allExpanded"></i>
                                    <i class="fas fa-caret-down"
                                        v-else></i>
                                </span>
                            </a>
                        </div>

                        <div class="fields-table">

                            <ul v-if="groupedFields.length > 0">
                                <li 
                                    class="field-group-box"
                                    v-for="(grp,grpIdx) in groupedFields"
                                    v-bind:key="grpIdx">
                                    <div 
                                        v-if="grp.isField === false">
                                        <b-field grouped>
                                            
                                            <div class="control">
                                                <b-dropdown>
                                                    <button type="button"
                                                        class="button is-small is-white"
                                                        slot="trigger"
                                                        role="button">
                                                        <span class="icon fa-sm">
                                                            <i class="fas fa-ellipsis-v fa-lg"></i>
                                                        </span>
                                                    </button>

                                                    <b-dropdown-item
                                                        @click="addToPositionNew({
                                                            fieldGroup: grp,
                                                            groupIdx: grpIdx
                                                        },null,'before',false)">
                                                        Add field before {{grp.fieldGroupName}}
                                                    </b-dropdown-item>

                                                    <b-dropdown-item
                                                        @click="addToPositionNew({
                                                            fieldGroup: grp,
                                                            groupIdx: grpIdx
                                                        },null,'after',false)">
                                                        Add field after {{grp.fieldGroupName}}
                                                    </b-dropdown-item>

                                                    <hr class="dropdown-divider" />

                                                    <b-dropdown-item
                                                        @click="addToPositionNew({
                                                            fieldGroup: grp,
                                                            groupIdx: grpIdx
                                                        },null,'before',true)">
                                                        Add field group before {{grp.fieldGroupName}}
                                                    </b-dropdown-item>

                                                    <b-dropdown-item
                                                        @click="addToPositionNew({
                                                            fieldGroup: grp,
                                                            groupIdx: grpIdx
                                                        },null,'after',true)">
                                                        Add field group after {{grp.fieldGroupName}}
                                                    </b-dropdown-item>

                                                    <hr class="dropdown-divider" />

                                                    <b-dropdown-item
                                                        v-on:click="confirmDeleteFieldGroup({
                                                            fieldGroup: grp,
                                                            groupIdx: grpIdx
                                                        })">
                                                        Delete field group (Including Fields)
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>

                                            <p class="control">
                                                <button 
                                                    type="button"
                                                    class="button is-white is-rounded is-small tooltip is-tooltip-top"
                                                    :data-tooltip="grp.expanded ? 'Click to hide field/s' : 'Click to show field/s'" 
                                                    @click="grp.expanded = !grp.expanded">
                                                    <span class="icon">
                                                        <i class="fas fa-caret-up"
                                                            v-if="grp.expanded"></i>
                                                        <i class="fas fa-caret-down"
                                                            v-else></i>
                                                    </span>
                                                </button>
                                            </p>

                                            <div class="field is-horizontal"
                                                style="width:45%;max-width:48%">
                                                <div class="field-label is-small">
                                                    <label class="label">Field Group</label>
                                                </div>
                                                <div class="field-body">
                                                    <b-input 
                                                        size="is-small"
                                                        type="text"
                                                        v-model="grp.fieldGroupName"
                                                        expanded
                                                        @input="updateGroupDetails(grp)"
                                                        style="width:99%"></b-input>
                                                </div>
                                            </div>

                                            <div class="field is-horizontal"
                                                style="width:45%;max-width:48%">
                                                <div class="field-label is-small"
                                                    style="min-width:130px">
                                                    <label class="label">Field Group Sublabel</label>
                                                </div>
                                                <div class="field-body">
                                                    <b-input 
                                                        size="is-small"
                                                        type="text"
                                                        v-model="grp.fieldGroupSubLabel"
                                                        @input="updateGroupDetails(grp)"
                                                        style="width:99%"></b-input>
                                                </div>
                                            </div>
                                        </b-field>
                                    </div>
                                    <hr style="margin:0.2rem auto;margin-bottom:0.7rem;"
                                        v-if="grp.isField === false && grp.expanded"/>
                                    <div v-if="grp.expanded">
                                        <div v-if="grp.fields.length > 0">
                                            <!-- Fields -->
                                            <div class="columns"
                                                v-for="(field,fieldIdx) in grp.fields"
                                                v-bind:key="fieldIdx">
                                                <div class="column is-1">
                                                    <div class="buttons are-small">
                                                        <b-dropdown aria-role="list">
                                                            <button class="button is-white tooltip is-tooltip-top"
                                                                data-tooltip="Add New Field" 
                                                                slot="trigger" 
                                                                slot-scope="{ active }">
                                                                <span class="icon ">
                                                                    <i class="fas fa-plus"></i>
                                                                </span>
                                                            </button>

                                                            <b-dropdown-item aria-role="listitem"
                                                                @click="addToPositionNew({
                                                                    fieldGroup: grp,
                                                                    groupIdx: grpIdx
                                                                },{
                                                                    index: fieldIdx,
                                                                    row: field
                                                                },'before',false)">
                                                                Add field before 
                                                                <span v-if="field.fieldLabel">
                                                                    {{field.fieldLabel}}
                                                                </span>
                                                                <span v-else>
                                                                    this field
                                                                </span>
                                                            </b-dropdown-item>
                                                            <b-dropdown-item aria-role="listitem"
                                                                @click="addToPositionNew({
                                                                    fieldGroup: grp,
                                                                    groupIdx: grpIdx
                                                                },{
                                                                    index: fieldIdx,
                                                                    row: field
                                                                },'after',false)">
                                                                Add field after 
                                                                <span v-if="field.fieldLabel">
                                                                    {{field.fieldLabel}}
                                                                </span>
                                                                <span v-else>
                                                                    this field
                                                                </span>
                                                            </b-dropdown-item>

                                                            <hr class="dropdown-divider" 
                                                                v-if="grp.isField"/>
                                                            <!-- Add Field Group Option -->
                                                            <b-dropdown-item aria-role="listitem"
                                                                v-if="grp.isField"
                                                                @click="addToPositionNew({
                                                                    fieldGroup: grp,
                                                                    groupIdx: grpIdx
                                                                },null,'before',true)">
                                                                Add field group before 
                                                                <span v-if="field.fieldLabel">
                                                                    {{field.fieldLabel}}
                                                                </span>
                                                                <span v-else>
                                                                    this field
                                                                </span>
                                                            </b-dropdown-item>
                                                            <b-dropdown-item aria-role="listitem"
                                                                v-if="grp.isField"
                                                                @click="addToPositionNew({
                                                                    fieldGroup: grp,
                                                                    groupIdx: grpIdx
                                                                },null,'after',true)">
                                                                Add field group after 
                                                                <span v-if="field.fieldLabel">
                                                                    {{field.fieldLabel}}
                                                                </span>
                                                                <span v-else>
                                                                    this field
                                                                </span>
                                                            </b-dropdown-item>

                                                        </b-dropdown>
                                                        <button type="button"
                                                            class="button is-white"
                                                            v-on:click="removeFieldNew({
                                                                    fieldGroup: grp,
                                                                    groupIdx: grpIdx
                                                                },{
                                                                index: fieldIdx,
                                                                row: field
                                                            })">
                                                            <span class="icon ">
                                                                <i class="fas fa-trash"></i>
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="column">
                                                    <b-field>
                                                        <b-input 
                                                            placeholder="Field Label"
                                                            type="text"
                                                            size="is-small"
                                                            v-model="field.fieldLabel"
                                                            required>
                                                        </b-input>
                                                    </b-field>
                                                </div>
                                                <div class="column">
                                                    <b-field>
                                                        <b-input 
                                                            placeholder="Field Sublabel"
                                                            type="text"
                                                            size="is-small"
                                                            v-model="field.fieldSubLabel">
                                                        </b-input>
                                                    </b-field>
                                                </div>
                                                <div class="column is-1">
                                                    <b-checkbox 
                                                        class="tooltip is-tooltip-top"
                                                        data-tooltip="Is field required?"
                                                        placeholder="Required"
                                                        size="is-small"
                                                        v-model="field.isRequired">
                                                        Required
                                                    </b-checkbox>
                                                </div>
                                                <div class="column is-2">
                                                    <b-field>
                                                        <b-select 
                                                            placeholder="Choose Input Type"
                                                            size="is-small"
                                                            v-model="field.fieldTypeIdFk"
                                                            required>
                                                            <option value="">None selected</option>
                                                            <option 
                                                                v-for="(inputType,inputTypeIdx) in inputTypesLov"
                                                                v-bind:key="inputTypeIdx"
                                                                v-bind:value="inputType.typeId">
                                                                {{inputType.inputType}}
                                                            </option>
                                                        </b-select>
                                                    </b-field>
                                                </div>
                                                <div class="column is-2">
                                                    <div v-if="field.fieldTypeIdFk!=null && getInputType(field.fieldTypeIdFk)=='dropdown'">
                                                        
                                                        <div class="buttons has-addons are-small">
                                                            <span class="button tooltip is-tooltip-top"
                                                                data-tooltip="Use Preset Options"
                                                                v-bind:class="{'is-info is-selected':field.optionType=='preset'}"
                                                                v-on:click="field.optionType = 'preset'">
                                                                Preset
                                                            </span>
                                                            <span class="button tooltip is-tooltip-top"
                                                                data-tooltip="Use Custom Options"
                                                                v-bind:class="{'is-info is-selected':field.optionType=='custom'}"
                                                                v-on:click="field.optionType = 'custom'">
                                                                Custom
                                                            </span>
                                                        </div>

                                                        <div v-if="field.optionType=='preset'">

                                                            <div class="field">
                                                                <b-radio 
                                                                    size="is-small"
                                                                    v-model="field.selectedPresetOption"
                                                                    native-value="Reporting Entities">
                                                                    Reporting Entities
                                                                </b-radio>
                                                            </div>
                                                            <div class="field">
                                                                <b-radio 
                                                                    size="is-small"
                                                                    v-model="field.selectedPresetOption"
                                                                    native-value="Reporting Entities & Units">
                                                                    Reporting Entities & Units
                                                                </b-radio>
                                                            </div>
                                                        </div>

                                                        <div v-if="field.optionType=='custom'">

                                                            <b-field>
                                                                <b-input 
                                                                    placeholder="Key in option name"
                                                                    type="text"
                                                                    size="is-small"
                                                                    v-model="field.dropdownInput"
                                                                    v-on:keyup.native.13="addDropdownOption({
                                                                        row: field,
                                                                        index: fieldIdx
                                                                    })">
                                                                </b-input>
                                                                <p class="control">
                                                                    <button 
                                                                        class="button is-small"
                                                                        title="Add Option"
                                                                        v-on:click="addDropdownOption({
                                                                            row: field,
                                                                            index: fieldIdx
                                                                        })">
                                                                        <span class="icon">
                                                                            <i class="fas fa-plus"></i>
                                                                        </span>
                                                                    </button>
                                                                </p>
                                                            </b-field>

                                                            <!-- List of custom options -->
                                                            <div class="tags"
                                                                v-if="field.customDropdownOptions.length">
                                                                <span class="tag is-small is-info"
                                                                    v-for="(ddOpt,ddOptIdx) in field.customDropdownOptions"
                                                                    v-bind:key="ddOptIdx">
                                                                    {{ddOpt}}
                                                                    <button class="delete is-small"
                                                                        v-on:click="removeDropdownOption({
                                                                            row: field,
                                                                            index: fieldIdx
                                                                        },ddOptIdx)"></button>
                                                                </span>
                                                            </div>

                                                        </div>

                                                    </div>

                                                    <!-- For checkbox/radio -->
                                                    <div v-if="field.fieldTypeIdFk!=null && (getInputType(field.fieldTypeIdFk)=='checkbox' || getInputType(field.fieldTypeIdFk)=='radio')">

                                                        <b-field>
                                                            <b-input 
                                                                placeholder="Key in option name"
                                                                type="text"
                                                                size="is-small"
                                                                v-model="field.dropdownInput"
                                                                v-on:keyup.native.13="addDropdownOption({
                                                                    index: fieldIdx,
                                                                    row: field
                                                                })">
                                                            </b-input>
                                                            <p class="control">
                                                                <button 
                                                                    class="button is-small"
                                                                    title="Add Option"
                                                                    v-on:click="addDropdownOption({
                                                                        index: fieldIdx,
                                                                        row: field
                                                                    })">
                                                                    <span class="icon">
                                                                        <i class="fas fa-plus"></i>
                                                                    </span>
                                                                </button>
                                                            </p>
                                                        </b-field>

                                                        <!-- List of custom options -->
                                                        <div class="tags"
                                                            v-if="field.customDropdownOptions.length">
                                                            <span class="tag is-small is-info"
                                                                v-for="(ddOpt,ddOptIdx) in field.customDropdownOptions"
                                                                v-bind:key="ddOptIdx">
                                                                {{ddOpt}}
                                                                <button class="delete is-small"
                                                                    v-on:click="removeDropdownOption({
                                                                        row: field,
                                                                        index: fieldIdx
                                                                    },ddOptIdx)"></button>
                                                            </span>
                                                        </div>

                                                    </div>

                                                    <small class="is-italic has-text-grey-light"
                                                        v-if="field.fieldTypeIdFk==null || hasOptions(field.fieldTypeIdFk)==false">Not Applicable</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else
                                            class="text-center">
                                            <div class="content has-text-grey has-text-centered">
                                                <p>No field found.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr 
                                        style="margin:0.2rem auto;margin-top:0.7rem;margin-bottom:0.7rem;" 
                                        v-if="grp.isField === false"/>
                                    <div
                                        v-if="grp.isField === false">
                                        <a class="button is-text is-small"
                                            v-on:click="addToPositionNew({
                                                fieldGroup: grp,
                                                groupIdx: grpIdx
                                            },null, null, false)">
                                            <span>Add new field to the group</span>
                                        </a>&nbsp;|&nbsp;
                                        <small class="has-text-weight-semibold is-textis-small"
                                        @click="grp.expanded = true">Number of fields: {{grp.fields.length}}</small>
                                    </div>
                                </li>
                            </ul>
                            <div v-else
                                class="text-center">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                            icon="emoticon-sad"
                                            size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>No data found.</p>
                                </div>
                            </div>
                        </div>


                        <hr />
                        
                        <div class="columns">
                            <div class="column is-narrow has-text-left">
                                <a class="button is-info is-outlined"
                                    v-on:click="addToPositionNew(null, null, null, true)">
                                    <span>New Field Group</span>
                                </a>
                                <a class="button is-info is-outlined"
                                    v-on:click="addToPositionNew(null, null, null, false)">
                                    <span>New Field</span>
                                </a>
                            </div>                  
                            <div class="column">
                                <!-- <a class="button"
                                    v-on:click="closeFieldMgt">
                                    Cancel
                                </a> -->
                                <a class="button"
                                    v-on:click="saveFormFields(0)">
                                    Save & Proceed
                                </a>
                                <!-- <a class="button is-success"
                                    v-on:click="saveFormFields(1)">
                                    Save & Proceed
                                </a> -->
                            </div>  
                        </div>

                    </div>

                </b-step-item>

                <!-- Step 4: Enable File Upload -->
                <b-step-item
                    label="Enable File Upload">

                    <div class="box form-fields-box">

                        <strong>Allow users to upload file/s to this form.</strong>
                        <div class="buttons has-addons">
                            <span class="button"
                                v-bind:class="{'is-info is-selected' : enableFileUpload}"
                                v-on:click="enableFileUpload=true">
                                Yes
                            </span>
                            <span class="button"
                                v-bind:class="{'is-info is-selected' :  !enableFileUpload}"
                                v-on:click="enableFileUpload=false">
                                No
                            </span>
                        </div>

                        <hr />
                        
                        <div class="columns">                 
                            <div class="column">
                                <a class="button"
                                    v-on:click="updatedFormFileField(0)">
                                    Save & Close
                                </a>
                                <a class="button is-success"
                                    v-on:click="updatedFormFileField(1)">
                                    Save & Publish Form
                                </a>
                            </div>  
                        </div>
                        
                    </div>
                </b-step-item>
            </b-steps>
        </div>
    </section>
</template>

<style scoped>
.form-access-grp {
    border:1px solid #e5e5e5;
    padding:5px 8px 0px 8px;
    border-radius:4px;
    margin-bottom:3px;
    min-width: 33%;
}
.form-access-grp__sub--entity{
    margin:1em auto;
    margin-left:2em;
    padding-right:1em;
}

.form-access-grp__sub--unit{
    margin:1em auto;
    margin-left:2.15em;
}

.form-access-grp__sub--entity .field,
.form-access-grp__sub--unit .field {
    border:none;
    border-top:1px solid #e5e5e5;
    padding: 7px 4px 5px 2px;
}

.form-restriction-table thead {
    border-bottom:2px solid rgb(165, 165, 165);
}

.form-restriction-table th {
    padding: 5px;
    padding-bottom: 10px;
}

.form-group-row {
    border-top:1px solid #e5e5e5;
    border-bottom:1px solid #e5e5e5;
    background-color: #f5f5f5;
}

.form-group-row > td {
    padding: 5px 0px 5px 5px;
}

.form-group-row:first-child > td {
    padding-top: 0.7em;
}

.form-group-row--entity > td {
    padding-top:0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.35em;
}
.form-group-row--entity > td:first-child {
    padding-left: 0.75em;
}

.form-group-list__units {
    display: block;
    margin-top: 0.65em;
    margin-left: 1em;
}

hr {
    margin:0.7rem 0;
}
.separator-v {
    display: inline-block;
    width:2px;
    height:17px;
    margin:0.3rem auto;
    border:none;
}
.sysad-field-delete {
    visibility: hidden;
}
.sysad-field:hover > .sysad-field-delete {
    visibility: visible;
}
</style>




// WEBPACK FOOTER //
// src/views/administration/AddFormView.vue